export const agreementForVendors = `<html>

<head>
    <meta content="text/html; charset=UTF-8" http-equiv="content-type">
    <style type="text/css">
        @import url('https://themes.googleusercontent.com/fonts/css?kit=dpiI8CyVsrzWsJLBFKehGpLhv3qFjX7dUn1mYxfCXhI');
        ol.lst-kix_5uxjq0ffbtjv-1.start {
            counter-reset: lst-ctn-kix_5uxjq0ffbtjv-1 0
        }

        ol.lst-kix_u7nuao8b0uit-6.start {
            counter-reset: lst-ctn-kix_u7nuao8b0uit-6 0
        }

        .lst-kix_5uxjq0ffbtjv-6>li {
            counter-increment: lst-ctn-kix_5uxjq0ffbtjv-6
        }

        .lst-kix_w17famkokbwp-7>li {
            counter-increment: lst-ctn-kix_w17famkokbwp-7
        }

        ol.lst-kix_9iardbj9zjtk-1 {
            list-style-type: none
        }

        ol.lst-kix_9iardbj9zjtk-0 {
            list-style-type: none
        }

        ol.lst-kix_9iardbj9zjtk-5 {
            list-style-type: none
        }

        ol.lst-kix_9iardbj9zjtk-4 {
            list-style-type: none
        }

        ol.lst-kix_9iardbj9zjtk-3 {
            list-style-type: none
        }

        ol.lst-kix_9iardbj9zjtk-2 {
            list-style-type: none
        }

        .lst-kix_w17famkokbwp-6>li:before {
            content: "" counter(lst-ctn-kix_w17famkokbwp-6, decimal) ". "
        }

        .lst-kix_19dyc6qu4pit-3>li {
            counter-increment: lst-ctn-kix_19dyc6qu4pit-3
        }

        ol.lst-kix_9iardbj9zjtk-8 {
            list-style-type: none
        }

        .lst-kix_w17famkokbwp-5>li:before {
            content: "" counter(lst-ctn-kix_w17famkokbwp-5, lower-roman) ". "
        }

        ol.lst-kix_9iardbj9zjtk-7 {
            list-style-type: none
        }

        ol.lst-kix_9iardbj9zjtk-6 {
            list-style-type: none
        }

        .lst-kix_w17famkokbwp-4>li:before {
            content: "" counter(lst-ctn-kix_w17famkokbwp-4, lower-latin) ". "
        }

        .lst-kix_bjin42889ms0-2>li {
            counter-increment: lst-ctn-kix_bjin42889ms0-2
        }

        .lst-kix_ewhhp7wzm8nf-8>li {
            counter-increment: lst-ctn-kix_ewhhp7wzm8nf-8
        }

        .lst-kix_w17famkokbwp-3>li:before {
            content: "" counter(lst-ctn-kix_w17famkokbwp-3, decimal) ". "
        }

        .lst-kix_5j8jfa1lr2qn-3>li:before {
            content: "" counter(lst-ctn-kix_5j8jfa1lr2qn-3, decimal) ". "
        }

        .lst-kix_5j8jfa1lr2qn-4>li:before {
            content: "" counter(lst-ctn-kix_5j8jfa1lr2qn-4, lower-latin) ". "
        }

        ol.lst-kix_5j8jfa1lr2qn-4.start {
            counter-reset: lst-ctn-kix_5j8jfa1lr2qn-4 0
        }

        ol.lst-kix_w17famkokbwp-5.start {
            counter-reset: lst-ctn-kix_w17famkokbwp-5 0
        }

        ol.lst-kix_lr8b0r9upydm-4.start {
            counter-reset: lst-ctn-kix_lr8b0r9upydm-4 0
        }

        .lst-kix_5j8jfa1lr2qn-2>li:before {
            content: "" counter(lst-ctn-kix_5j8jfa1lr2qn-2, lower-roman) ". "
        }

        .lst-kix_5j8jfa1lr2qn-6>li:before {
            content: "" counter(lst-ctn-kix_5j8jfa1lr2qn-6, decimal) ". "
        }

        .lst-kix_5j8jfa1lr2qn-0>li:before {
            content: "5." counter(lst-ctn-kix_5j8jfa1lr2qn-0, decimal) ". "
        }

        .lst-kix_5j8jfa1lr2qn-7>li:before {
            content: "" counter(lst-ctn-kix_5j8jfa1lr2qn-7, lower-latin) ". "
        }

        .lst-kix_5j8jfa1lr2qn-8>li:before {
            content: "" counter(lst-ctn-kix_5j8jfa1lr2qn-8, lower-roman) ". "
        }

        ol.lst-kix_9iardbj9zjtk-6.start {
            counter-reset: lst-ctn-kix_9iardbj9zjtk-6 0
        }

        .lst-kix_5j8jfa1lr2qn-1>li:before {
            content: "" counter(lst-ctn-kix_5j8jfa1lr2qn-1, lower-latin) ". "
        }

        .lst-kix_egh4jwb5e5bq-3>li {
            counter-increment: lst-ctn-kix_egh4jwb5e5bq-3
        }

        .lst-kix_w17famkokbwp-7>li:before {
            content: "" counter(lst-ctn-kix_w17famkokbwp-7, lower-latin) ". "
        }

        .lst-kix_w17famkokbwp-8>li:before {
            content: "" counter(lst-ctn-kix_w17famkokbwp-8, lower-roman) ". "
        }

        .lst-kix_9iardbj9zjtk-7>li {
            counter-increment: lst-ctn-kix_9iardbj9zjtk-7
        }

        ol.lst-kix_egh4jwb5e5bq-1.start {
            counter-reset: lst-ctn-kix_egh4jwb5e5bq-1 0
        }

        ol.lst-kix_u7nuao8b0uit-1.start {
            counter-reset: lst-ctn-kix_u7nuao8b0uit-1 0
        }

        .lst-kix_5j8jfa1lr2qn-5>li:before {
            content: "" counter(lst-ctn-kix_5j8jfa1lr2qn-5, lower-roman) ". "
        }

        .lst-kix_5u6c3bimbh7o-6>li {
            counter-increment: lst-ctn-kix_5u6c3bimbh7o-6
        }

        ol.lst-kix_ewhhp7wzm8nf-4.start {
            counter-reset: lst-ctn-kix_ewhhp7wzm8nf-4 0
        }

        ol.lst-kix_a2xpqrabpe6x-8.start {
            counter-reset: lst-ctn-kix_a2xpqrabpe6x-8 0
        }

        .lst-kix_ewhhp7wzm8nf-4>li {
            counter-increment: lst-ctn-kix_ewhhp7wzm8nf-4
        }

        ol.lst-kix_a2xpqrabpe6x-1.start {
            counter-reset: lst-ctn-kix_a2xpqrabpe6x-1 0
        }

        .lst-kix_w17famkokbwp-0>li:before {
            content: "" counter(lst-ctn-kix_w17famkokbwp-0, decimal) ". "
        }

        .lst-kix_w17famkokbwp-2>li:before {
            content: "" counter(lst-ctn-kix_w17famkokbwp-2, lower-roman) ". "
        }

        .lst-kix_w17famkokbwp-1>li:before {
            content: "" counter(lst-ctn-kix_w17famkokbwp-1, lower-latin) ". "
        }

        .lst-kix_a2xpqrabpe6x-6>li {
            counter-increment: lst-ctn-kix_a2xpqrabpe6x-6
        }

        .lst-kix_bjin42889ms0-6>li {
            counter-increment: lst-ctn-kix_bjin42889ms0-6
        }

        .lst-kix_u7nuao8b0uit-8>li {
            counter-increment: lst-ctn-kix_u7nuao8b0uit-8
        }

        ol.lst-kix_bjin42889ms0-6.start {
            counter-reset: lst-ctn-kix_bjin42889ms0-6 0
        }

        .lst-kix_ewhhp7wzm8nf-1>li {
            counter-increment: lst-ctn-kix_ewhhp7wzm8nf-1
        }

        .lst-kix_u7nuao8b0uit-4>li {
            counter-increment: lst-ctn-kix_u7nuao8b0uit-4
        }

        .lst-kix_5j8jfa1lr2qn-3>li {
            counter-increment: lst-ctn-kix_5j8jfa1lr2qn-3
        }

        .lst-kix_a2xpqrabpe6x-2>li {
            counter-increment: lst-ctn-kix_a2xpqrabpe6x-2
        }

        ol.lst-kix_egh4jwb5e5bq-8.start {
            counter-reset: lst-ctn-kix_egh4jwb5e5bq-8 0
        }

        .lst-kix_egh4jwb5e5bq-7>li {
            counter-increment: lst-ctn-kix_egh4jwb5e5bq-7
        }

        ol.lst-kix_5u6c3bimbh7o-4.start {
            counter-reset: lst-ctn-kix_5u6c3bimbh7o-4 0
        }

        .lst-kix_9iardbj9zjtk-4>li {
            counter-increment: lst-ctn-kix_9iardbj9zjtk-4
        }

        .lst-kix_19dyc6qu4pit-7>li {
            counter-increment: lst-ctn-kix_19dyc6qu4pit-7
        }

        ol.lst-kix_19dyc6qu4pit-4.start {
            counter-reset: lst-ctn-kix_19dyc6qu4pit-4 0
        }

        .lst-kix_ewhhp7wzm8nf-6>li:before {
            content: "" counter(lst-ctn-kix_ewhhp7wzm8nf-6, decimal) ". "
        }

        ol.lst-kix_u7nuao8b0uit-8.start {
            counter-reset: lst-ctn-kix_u7nuao8b0uit-8 0
        }

        ol.lst-kix_egh4jwb5e5bq-6.start {
            counter-reset: lst-ctn-kix_egh4jwb5e5bq-6 0
        }

        .lst-kix_ewhhp7wzm8nf-0>li:before {
            content: "4." counter(lst-ctn-kix_ewhhp7wzm8nf-0, decimal) ". "
        }

        .lst-kix_ewhhp7wzm8nf-8>li:before {
            content: "" counter(lst-ctn-kix_ewhhp7wzm8nf-8, lower-roman) ". "
        }

        .lst-kix_lr8b0r9upydm-2>li {
            counter-increment: lst-ctn-kix_lr8b0r9upydm-2
        }

        ol.lst-kix_w17famkokbwp-7.start {
            counter-reset: lst-ctn-kix_w17famkokbwp-7 0
        }

        .lst-kix_bjin42889ms0-3>li:before {
            content: "" counter(lst-ctn-kix_bjin42889ms0-3, decimal) ". "
        }

        .lst-kix_19dyc6qu4pit-6>li {
            counter-increment: lst-ctn-kix_19dyc6qu4pit-6
        }

        .lst-kix_bjin42889ms0-1>li:before {
            content: "" counter(lst-ctn-kix_bjin42889ms0-1, lower-latin) ". "
        }

        .lst-kix_ewhhp7wzm8nf-2>li:before {
            content: "" counter(lst-ctn-kix_ewhhp7wzm8nf-2, lower-roman) ". "
        }

        .lst-kix_lr8b0r9upydm-3>li {
            counter-increment: lst-ctn-kix_lr8b0r9upydm-3
        }

        .lst-kix_w17famkokbwp-3>li {
            counter-increment: lst-ctn-kix_w17famkokbwp-3
        }

        .lst-kix_ewhhp7wzm8nf-4>li:before {
            content: "" counter(lst-ctn-kix_ewhhp7wzm8nf-4, lower-latin) ". "
        }

        .lst-kix_bjin42889ms0-5>li {
            counter-increment: lst-ctn-kix_bjin42889ms0-5
        }

        ol.lst-kix_19dyc6qu4pit-2.start {
            counter-reset: lst-ctn-kix_19dyc6qu4pit-2 0
        }

        ol.lst-kix_5u6c3bimbh7o-6.start {
            counter-reset: lst-ctn-kix_5u6c3bimbh7o-6 0
        }

        ol.lst-kix_9iardbj9zjtk-8.start {
            counter-reset: lst-ctn-kix_9iardbj9zjtk-8 0
        }

        ol.lst-kix_lr8b0r9upydm-2.start {
            counter-reset: lst-ctn-kix_lr8b0r9upydm-2 0
        }

        .lst-kix_19dyc6qu4pit-0>li {
            counter-increment: lst-ctn-kix_19dyc6qu4pit-0
        }

        ol.lst-kix_ewhhp7wzm8nf-1.start {
            counter-reset: lst-ctn-kix_ewhhp7wzm8nf-1 0
        }

        .lst-kix_bjin42889ms0-5>li:before {
            content: "" counter(lst-ctn-kix_bjin42889ms0-5, lower-roman) ". "
        }

        .lst-kix_bjin42889ms0-7>li:before {
            content: "" counter(lst-ctn-kix_bjin42889ms0-7, lower-latin) ". "
        }

        .lst-kix_egh4jwb5e5bq-2>li {
            counter-increment: lst-ctn-kix_egh4jwb5e5bq-2
        }

        ol.lst-kix_5j8jfa1lr2qn-6.start {
            counter-reset: lst-ctn-kix_5j8jfa1lr2qn-6 0
        }

        .lst-kix_9iardbj9zjtk-3>li {
            counter-increment: lst-ctn-kix_9iardbj9zjtk-3
        }

        .lst-kix_5u6c3bimbh7o-2>li {
            counter-increment: lst-ctn-kix_5u6c3bimbh7o-2
        }

        .lst-kix_ewhhp7wzm8nf-0>li {
            counter-increment: lst-ctn-kix_ewhhp7wzm8nf-0
        }

        .lst-kix_5j8jfa1lr2qn-4>li {
            counter-increment: lst-ctn-kix_5j8jfa1lr2qn-4
        }

        .lst-kix_5u6c3bimbh7o-3>li {
            counter-increment: lst-ctn-kix_5u6c3bimbh7o-3
        }

        .lst-kix_ewhhp7wzm8nf-7>li {
            counter-increment: lst-ctn-kix_ewhhp7wzm8nf-7
        }

        .lst-kix_19dyc6qu4pit-2>li {
            counter-increment: lst-ctn-kix_19dyc6qu4pit-2
        }

        ol.lst-kix_ewhhp7wzm8nf-2.start {
            counter-reset: lst-ctn-kix_ewhhp7wzm8nf-2 0
        }

        ol.lst-kix_lr8b0r9upydm-1.start {
            counter-reset: lst-ctn-kix_lr8b0r9upydm-1 0
        }

        ol.lst-kix_5u6c3bimbh7o-2.start {
            counter-reset: lst-ctn-kix_5u6c3bimbh7o-2 0
        }

        ol.lst-kix_19dyc6qu4pit-0.start {
            counter-reset: lst-ctn-kix_19dyc6qu4pit-0 0
        }

        ol.lst-kix_w17famkokbwp-2.start {
            counter-reset: lst-ctn-kix_w17famkokbwp-2 0
        }

        .lst-kix_5uxjq0ffbtjv-5>li {
            counter-increment: lst-ctn-kix_5uxjq0ffbtjv-5
        }

        .lst-kix_w17famkokbwp-6>li {
            counter-increment: lst-ctn-kix_w17famkokbwp-6
        }

        .lst-kix_9iardbj9zjtk-8>li {
            counter-increment: lst-ctn-kix_9iardbj9zjtk-8
        }

        .lst-kix_egh4jwb5e5bq-0>li {
            counter-increment: lst-ctn-kix_egh4jwb5e5bq-0
        }

        ol.lst-kix_9iardbj9zjtk-3.start {
            counter-reset: lst-ctn-kix_9iardbj9zjtk-3 0
        }

        ol.lst-kix_w17famkokbwp-1 {
            list-style-type: none
        }

        .lst-kix_w17famkokbwp-8>li {
            counter-increment: lst-ctn-kix_w17famkokbwp-8
        }

        ol.lst-kix_w17famkokbwp-0 {
            list-style-type: none
        }

        ol.lst-kix_w17famkokbwp-3 {
            list-style-type: none
        }

        ol.lst-kix_w17famkokbwp-2 {
            list-style-type: none
        }

        ol.lst-kix_w17famkokbwp-5 {
            list-style-type: none
        }

        ol.lst-kix_w17famkokbwp-4 {
            list-style-type: none
        }

        ol.lst-kix_w17famkokbwp-7 {
            list-style-type: none
        }

        .lst-kix_19dyc6qu4pit-4>li {
            counter-increment: lst-ctn-kix_19dyc6qu4pit-4
        }

        ol.lst-kix_w17famkokbwp-6 {
            list-style-type: none
        }

        ol.lst-kix_w17famkokbwp-8 {
            list-style-type: none
        }

        .lst-kix_a2xpqrabpe6x-7>li {
            counter-increment: lst-ctn-kix_a2xpqrabpe6x-7
        }

        ol.lst-kix_a2xpqrabpe6x-5.start {
            counter-reset: lst-ctn-kix_a2xpqrabpe6x-5 0
        }

        .lst-kix_5uxjq0ffbtjv-7>li {
            counter-increment: lst-ctn-kix_5uxjq0ffbtjv-7
        }

        ol.lst-kix_egh4jwb5e5bq-4.start {
            counter-reset: lst-ctn-kix_egh4jwb5e5bq-4 0
        }

        ol.lst-kix_5j8jfa1lr2qn-1.start {
            counter-reset: lst-ctn-kix_5j8jfa1lr2qn-1 0
        }

        .lst-kix_egh4jwb5e5bq-0>li:before {
            content: "" counter(lst-ctn-kix_egh4jwb5e5bq-0, decimal) ". "
        }

        .lst-kix_w17famkokbwp-4>li {
            counter-increment: lst-ctn-kix_w17famkokbwp-4
        }

        ol.lst-kix_5u6c3bimbh7o-3.start {
            counter-reset: lst-ctn-kix_5u6c3bimbh7o-3 0
        }

        ol.lst-kix_9iardbj9zjtk-4.start {
            counter-reset: lst-ctn-kix_9iardbj9zjtk-4 0
        }

        ol.lst-kix_5j8jfa1lr2qn-2.start {
            counter-reset: lst-ctn-kix_5j8jfa1lr2qn-2 0
        }

        ol.lst-kix_lr8b0r9upydm-0.start {
            counter-reset: lst-ctn-kix_lr8b0r9upydm-0 0
        }

        .lst-kix_5u6c3bimbh7o-7>li {
            counter-increment: lst-ctn-kix_5u6c3bimbh7o-7
        }

        ol.lst-kix_u7nuao8b0uit-2 {
            list-style-type: none
        }

        ol.lst-kix_u7nuao8b0uit-3 {
            list-style-type: none
        }

        ol.lst-kix_u7nuao8b0uit-4 {
            list-style-type: none
        }

        ol.lst-kix_u7nuao8b0uit-5 {
            list-style-type: none
        }

        ol.lst-kix_egh4jwb5e5bq-3.start {
            counter-reset: lst-ctn-kix_egh4jwb5e5bq-3 0
        }

        ol.lst-kix_u7nuao8b0uit-0 {
            list-style-type: none
        }

        .lst-kix_lr8b0r9upydm-6>li:before {
            content: "" counter(lst-ctn-kix_lr8b0r9upydm-6, decimal) ". "
        }

        ol.lst-kix_a2xpqrabpe6x-0.start {
            counter-reset: lst-ctn-kix_a2xpqrabpe6x-0 0
        }

        ol.lst-kix_u7nuao8b0uit-1 {
            list-style-type: none
        }

        ol.lst-kix_w17famkokbwp-3.start {
            counter-reset: lst-ctn-kix_w17famkokbwp-3 0
        }

        .lst-kix_a2xpqrabpe6x-3>li {
            counter-increment: lst-ctn-kix_a2xpqrabpe6x-3
        }

        .lst-kix_a2xpqrabpe6x-0>li {
            counter-increment: lst-ctn-kix_a2xpqrabpe6x-0
        }

        .lst-kix_lr8b0r9upydm-1>li:before {
            content: "" counter(lst-ctn-kix_lr8b0r9upydm-1, lower-latin) ". "
        }

        .lst-kix_lr8b0r9upydm-2>li:before {
            content: "" counter(lst-ctn-kix_lr8b0r9upydm-2, lower-roman) ". "
        }

        .lst-kix_lr8b0r9upydm-4>li {
            counter-increment: lst-ctn-kix_lr8b0r9upydm-4
        }

        .lst-kix_u7nuao8b0uit-2>li {
            counter-increment: lst-ctn-kix_u7nuao8b0uit-2
        }

        .lst-kix_lr8b0r9upydm-5>li:before {
            content: "" counter(lst-ctn-kix_lr8b0r9upydm-5, lower-roman) ". "
        }

        ol.lst-kix_u7nuao8b0uit-6 {
            list-style-type: none
        }

        ol.lst-kix_u7nuao8b0uit-7 {
            list-style-type: none
        }

        .lst-kix_u7nuao8b0uit-5>li {
            counter-increment: lst-ctn-kix_u7nuao8b0uit-5
        }

        ol.lst-kix_u7nuao8b0uit-8 {
            list-style-type: none
        }

        .lst-kix_5uxjq0ffbtjv-2>li:before {
            content: "" counter(lst-ctn-kix_5uxjq0ffbtjv-2, lower-roman) ". "
        }

        .lst-kix_w17famkokbwp-1>li {
            counter-increment: lst-ctn-kix_w17famkokbwp-1
        }

        .lst-kix_5j8jfa1lr2qn-2>li {
            counter-increment: lst-ctn-kix_5j8jfa1lr2qn-2
        }

        ol.lst-kix_9iardbj9zjtk-2.start {
            counter-reset: lst-ctn-kix_9iardbj9zjtk-2 0
        }

        ol.lst-kix_a2xpqrabpe6x-3.start {
            counter-reset: lst-ctn-kix_a2xpqrabpe6x-3 0
        }

        ol.lst-kix_5j8jfa1lr2qn-0 {
            list-style-type: none
        }

        .lst-kix_9iardbj9zjtk-1>li {
            counter-increment: lst-ctn-kix_9iardbj9zjtk-1
        }

        ol.lst-kix_5j8jfa1lr2qn-2 {
            list-style-type: none
        }

        ol.lst-kix_5j8jfa1lr2qn-1 {
            list-style-type: none
        }

        .lst-kix_5uxjq0ffbtjv-6>li:before {
            content: "" counter(lst-ctn-kix_5uxjq0ffbtjv-6, decimal) ". "
        }

        ol.lst-kix_5j8jfa1lr2qn-4 {
            list-style-type: none
        }

        .lst-kix_ewhhp7wzm8nf-2>li {
            counter-increment: lst-ctn-kix_ewhhp7wzm8nf-2
        }

        ol.lst-kix_5j8jfa1lr2qn-0.start {
            counter-reset: lst-ctn-kix_5j8jfa1lr2qn-0 0
        }

        ol.lst-kix_5j8jfa1lr2qn-3 {
            list-style-type: none
        }

        ol.lst-kix_5j8jfa1lr2qn-6 {
            list-style-type: none
        }

        ol.lst-kix_5j8jfa1lr2qn-5 {
            list-style-type: none
        }

        ol.lst-kix_5j8jfa1lr2qn-8 {
            list-style-type: none
        }

        ol.lst-kix_a2xpqrabpe6x-6.start {
            counter-reset: lst-ctn-kix_a2xpqrabpe6x-6 0
        }

        ol.lst-kix_5j8jfa1lr2qn-7 {
            list-style-type: none
        }

        ol.lst-kix_egh4jwb5e5bq-0.start {
            counter-reset: lst-ctn-kix_egh4jwb5e5bq-0 0
        }

        .lst-kix_lr8b0r9upydm-6>li {
            counter-increment: lst-ctn-kix_lr8b0r9upydm-6
        }

        .lst-kix_5j8jfa1lr2qn-0>li {
            counter-increment: lst-ctn-kix_5j8jfa1lr2qn-0
        }

        ol.lst-kix_ewhhp7wzm8nf-6.start {
            counter-reset: lst-ctn-kix_ewhhp7wzm8nf-6 0
        }

        ol.lst-kix_w17famkokbwp-1.start {
            counter-reset: lst-ctn-kix_w17famkokbwp-1 0
        }

        ol.lst-kix_a2xpqrabpe6x-5 {
            list-style-type: none
        }

        ol.lst-kix_a2xpqrabpe6x-6 {
            list-style-type: none
        }

        ol.lst-kix_a2xpqrabpe6x-7 {
            list-style-type: none
        }

        ol.lst-kix_a2xpqrabpe6x-8 {
            list-style-type: none
        }

        .lst-kix_bjin42889ms0-7>li {
            counter-increment: lst-ctn-kix_bjin42889ms0-7
        }

        ol.lst-kix_5u6c3bimbh7o-1.start {
            counter-reset: lst-ctn-kix_5u6c3bimbh7o-1 0
        }

        .lst-kix_19dyc6qu4pit-4>li:before {
            content: "" counter(lst-ctn-kix_19dyc6qu4pit-4, lower-latin) ". "
        }

        .lst-kix_ewhhp7wzm8nf-5>li:before {
            content: "" counter(lst-ctn-kix_ewhhp7wzm8nf-5, lower-roman) ". "
        }

        .lst-kix_egh4jwb5e5bq-3>li:before {
            content: "" counter(lst-ctn-kix_egh4jwb5e5bq-3, decimal) ". "
        }

        .lst-kix_u7nuao8b0uit-7>li {
            counter-increment: lst-ctn-kix_u7nuao8b0uit-7
        }

        ol.lst-kix_a2xpqrabpe6x-1 {
            list-style-type: none
        }

        ol.lst-kix_a2xpqrabpe6x-2 {
            list-style-type: none
        }

        .lst-kix_19dyc6qu4pit-0>li:before {
            content: "" counter(lst-ctn-kix_19dyc6qu4pit-0, decimal) ". "
        }

        .lst-kix_19dyc6qu4pit-8>li:before {
            content: "" counter(lst-ctn-kix_19dyc6qu4pit-8, lower-roman) ". "
        }

        ol.lst-kix_a2xpqrabpe6x-3 {
            list-style-type: none
        }

        ol.lst-kix_a2xpqrabpe6x-4 {
            list-style-type: none
        }

        ol.lst-kix_a2xpqrabpe6x-0 {
            list-style-type: none
        }

        .lst-kix_a2xpqrabpe6x-1>li:before {
            content: "7.1." counter(lst-ctn-kix_a2xpqrabpe6x-1, decimal) ". "
        }

        ol.lst-kix_a2xpqrabpe6x-4.start {
            counter-reset: lst-ctn-kix_a2xpqrabpe6x-4 0
        }

        .lst-kix_a2xpqrabpe6x-5>li {
            counter-increment: lst-ctn-kix_a2xpqrabpe6x-5
        }

        .lst-kix_ewhhp7wzm8nf-1>li:before {
            content: "" counter(lst-ctn-kix_ewhhp7wzm8nf-1, lower-latin) ". "
        }

        .lst-kix_egh4jwb5e5bq-7>li:before {
            content: "" counter(lst-ctn-kix_egh4jwb5e5bq-7, lower-latin) ". "
        }

        ol.lst-kix_w17famkokbwp-0.start {
            counter-reset: lst-ctn-kix_w17famkokbwp-0 0
        }

        .lst-kix_bjin42889ms0-2>li:before {
            content: "" counter(lst-ctn-kix_bjin42889ms0-2, lower-roman) ". "
        }

        ol.lst-kix_5u6c3bimbh7o-0.start {
            counter-reset: lst-ctn-kix_5u6c3bimbh7o-0 0
        }

        ol.lst-kix_ewhhp7wzm8nf-7.start {
            counter-reset: lst-ctn-kix_ewhhp7wzm8nf-7 0
        }

        .lst-kix_5uxjq0ffbtjv-2>li {
            counter-increment: lst-ctn-kix_5uxjq0ffbtjv-2
        }

        .lst-kix_u7nuao8b0uit-0>li {
            counter-increment: lst-ctn-kix_u7nuao8b0uit-0
        }

        .lst-kix_9iardbj9zjtk-0>li:before {
            content: "2." counter(lst-ctn-kix_9iardbj9zjtk-0, decimal) ". "
        }

        ol.lst-kix_9iardbj9zjtk-1.start {
            counter-reset: lst-ctn-kix_9iardbj9zjtk-1 0
        }

        .lst-kix_9iardbj9zjtk-6>li {
            counter-increment: lst-ctn-kix_9iardbj9zjtk-6
        }

        .lst-kix_9iardbj9zjtk-8>li:before {
            content: "" counter(lst-ctn-kix_9iardbj9zjtk-8, lower-roman) ". "
        }

        .lst-kix_5u6c3bimbh7o-5>li {
            counter-increment: lst-ctn-kix_5u6c3bimbh7o-5
        }

        .lst-kix_egh4jwb5e5bq-5>li {
            counter-increment: lst-ctn-kix_egh4jwb5e5bq-5
        }

        .lst-kix_bjin42889ms0-6>li:before {
            content: "" counter(lst-ctn-kix_bjin42889ms0-6, decimal) ". "
        }

        .lst-kix_9iardbj9zjtk-4>li:before {
            content: "" counter(lst-ctn-kix_9iardbj9zjtk-4, lower-latin) ". "
        }

        ol.lst-kix_ewhhp7wzm8nf-8.start {
            counter-reset: lst-ctn-kix_ewhhp7wzm8nf-8 0
        }

        .lst-kix_5j8jfa1lr2qn-7>li {
            counter-increment: lst-ctn-kix_5j8jfa1lr2qn-7
        }

        .lst-kix_a2xpqrabpe6x-5>li:before {
            content: "" counter(lst-ctn-kix_a2xpqrabpe6x-5, lower-roman) ". "
        }

        ol.lst-kix_5u6c3bimbh7o-5.start {
            counter-reset: lst-ctn-kix_5u6c3bimbh7o-5 0
        }

        ol.lst-kix_19dyc6qu4pit-3.start {
            counter-reset: lst-ctn-kix_19dyc6qu4pit-3 0
        }

        ol.lst-kix_bjin42889ms0-5.start {
            counter-reset: lst-ctn-kix_bjin42889ms0-5 0
        }

        .lst-kix_egh4jwb5e5bq-1>li {
            counter-increment: lst-ctn-kix_egh4jwb5e5bq-1
        }

        .lst-kix_5u6c3bimbh7o-4>li {
            counter-increment: lst-ctn-kix_5u6c3bimbh7o-4
        }

        ol.lst-kix_5uxjq0ffbtjv-7.start {
            counter-reset: lst-ctn-kix_5uxjq0ffbtjv-7 0
        }

        ol.lst-kix_a2xpqrabpe6x-2.start {
            counter-reset: lst-ctn-kix_a2xpqrabpe6x-2 0
        }

        .lst-kix_w17famkokbwp-5>li {
            counter-increment: lst-ctn-kix_w17famkokbwp-5
        }

        ol.lst-kix_egh4jwb5e5bq-7.start {
            counter-reset: lst-ctn-kix_egh4jwb5e5bq-7 0
        }

        ol.lst-kix_lr8b0r9upydm-1 {
            list-style-type: none
        }

        .lst-kix_19dyc6qu4pit-1>li {
            counter-increment: lst-ctn-kix_19dyc6qu4pit-1
        }

        .lst-kix_5uxjq0ffbtjv-4>li {
            counter-increment: lst-ctn-kix_5uxjq0ffbtjv-4
        }

        ol.lst-kix_lr8b0r9upydm-2 {
            list-style-type: none
        }

        ol.lst-kix_lr8b0r9upydm-0 {
            list-style-type: none
        }

        ol.lst-kix_lr8b0r9upydm-5 {
            list-style-type: none
        }

        ol.lst-kix_lr8b0r9upydm-6 {
            list-style-type: none
        }

        ol.lst-kix_lr8b0r9upydm-3 {
            list-style-type: none
        }

        ol.lst-kix_9iardbj9zjtk-0.start {
            counter-reset: lst-ctn-kix_9iardbj9zjtk-0 0
        }

        ol.lst-kix_lr8b0r9upydm-4 {
            list-style-type: none
        }

        .lst-kix_5u6c3bimbh7o-5>li:before {
            content: "" counter(lst-ctn-kix_5u6c3bimbh7o-5, lower-roman) ". "
        }

        .lst-kix_19dyc6qu4pit-5>li {
            counter-increment: lst-ctn-kix_19dyc6qu4pit-5
        }

        .lst-kix_5u6c3bimbh7o-0>li {
            counter-increment: lst-ctn-kix_5u6c3bimbh7o-0
        }

        .lst-kix_5u6c3bimbh7o-4>li:before {
            content: "" counter(lst-ctn-kix_5u6c3bimbh7o-4, lower-latin) ". "
        }

        .lst-kix_5u6c3bimbh7o-6>li:before {
            content: "" counter(lst-ctn-kix_5u6c3bimbh7o-6, decimal) ". "
        }

        .lst-kix_u7nuao8b0uit-0>li:before {
            content: "1." counter(lst-ctn-kix_u7nuao8b0uit-0, decimal) ". "
        }

        ol.lst-kix_bjin42889ms0-0.start {
            counter-reset: lst-ctn-kix_bjin42889ms0-0 0
        }

        .lst-kix_5j8jfa1lr2qn-5>li {
            counter-increment: lst-ctn-kix_5j8jfa1lr2qn-5
        }

        ol.lst-kix_w17famkokbwp-4.start {
            counter-reset: lst-ctn-kix_w17famkokbwp-4 0
        }

        .lst-kix_u7nuao8b0uit-1>li:before {
            content: "" counter(lst-ctn-kix_u7nuao8b0uit-1, lower-latin) ". "
        }

        .lst-kix_5u6c3bimbh7o-1>li:before {
            content: "" counter(lst-ctn-kix_5u6c3bimbh7o-1, lower-latin) ". "
        }

        .lst-kix_u7nuao8b0uit-3>li:before {
            content: "" counter(lst-ctn-kix_u7nuao8b0uit-3, decimal) ". "
        }

        .lst-kix_5u6c3bimbh7o-0>li:before {
            content: "" counter(lst-ctn-kix_5u6c3bimbh7o-0, decimal) ". "
        }

        .lst-kix_5u6c3bimbh7o-8>li:before {
            content: "" counter(lst-ctn-kix_5u6c3bimbh7o-8, lower-roman) ". "
        }

        .lst-kix_u7nuao8b0uit-2>li:before {
            content: "" counter(lst-ctn-kix_u7nuao8b0uit-2, lower-roman) ". "
        }

        .lst-kix_u7nuao8b0uit-4>li:before {
            content: "" counter(lst-ctn-kix_u7nuao8b0uit-4, lower-latin) ". "
        }

        .lst-kix_5u6c3bimbh7o-7>li:before {
            content: "" counter(lst-ctn-kix_5u6c3bimbh7o-7, lower-latin) ". "
        }

        ol.lst-kix_egh4jwb5e5bq-2.start {
            counter-reset: lst-ctn-kix_egh4jwb5e5bq-2 0
        }

        .lst-kix_u7nuao8b0uit-7>li:before {
            content: "" counter(lst-ctn-kix_u7nuao8b0uit-7, lower-latin) ". "
        }

        .lst-kix_u7nuao8b0uit-6>li:before {
            content: "" counter(lst-ctn-kix_u7nuao8b0uit-6, decimal) ". "
        }

        .lst-kix_u7nuao8b0uit-8>li:before {
            content: "" counter(lst-ctn-kix_u7nuao8b0uit-8, lower-roman) ". "
        }

        .lst-kix_u7nuao8b0uit-5>li:before {
            content: "" counter(lst-ctn-kix_u7nuao8b0uit-5, lower-roman) ". "
        }

        ol.lst-kix_u7nuao8b0uit-5.start {
            counter-reset: lst-ctn-kix_u7nuao8b0uit-5 0
        }

        .lst-kix_5u6c3bimbh7o-2>li:before {
            content: "" counter(lst-ctn-kix_5u6c3bimbh7o-2, lower-roman) ". "
        }

        .lst-kix_5u6c3bimbh7o-3>li:before {
            content: "" counter(lst-ctn-kix_5u6c3bimbh7o-3, decimal) ". "
        }

        ol.lst-kix_5uxjq0ffbtjv-2.start {
            counter-reset: lst-ctn-kix_5uxjq0ffbtjv-2 0
        }

        .lst-kix_9iardbj9zjtk-5>li {
            counter-increment: lst-ctn-kix_9iardbj9zjtk-5
        }

        .lst-kix_bjin42889ms0-0>li {
            counter-increment: lst-ctn-kix_bjin42889ms0-0
        }

        ol.lst-kix_u7nuao8b0uit-0.start {
            counter-reset: lst-ctn-kix_u7nuao8b0uit-0 0
        }

        ol.lst-kix_a2xpqrabpe6x-7.start {
            counter-reset: lst-ctn-kix_a2xpqrabpe6x-7 0
        }

        ol.lst-kix_ewhhp7wzm8nf-5.start {
            counter-reset: lst-ctn-kix_ewhhp7wzm8nf-5 0
        }

        .lst-kix_lr8b0r9upydm-1>li {
            counter-increment: lst-ctn-kix_lr8b0r9upydm-1
        }

        ol.lst-kix_9iardbj9zjtk-5.start {
            counter-reset: lst-ctn-kix_9iardbj9zjtk-5 0
        }

        .lst-kix_5uxjq0ffbtjv-0>li:before {
            content: "6." counter(lst-ctn-kix_5uxjq0ffbtjv-0, decimal) ". "
        }

        .lst-kix_5uxjq0ffbtjv-0>li {
            counter-increment: lst-ctn-kix_5uxjq0ffbtjv-0
        }

        .lst-kix_5uxjq0ffbtjv-1>li:before {
            content: "6.4." counter(lst-ctn-kix_5uxjq0ffbtjv-1, decimal) ". "
        }

        .lst-kix_9iardbj9zjtk-2>li {
            counter-increment: lst-ctn-kix_9iardbj9zjtk-2
        }

        .lst-kix_5uxjq0ffbtjv-3>li:before {
            content: "" counter(lst-ctn-kix_5uxjq0ffbtjv-3, decimal) ". "
        }

        ol.lst-kix_lr8b0r9upydm-5.start {
            counter-reset: lst-ctn-kix_lr8b0r9upydm-5 0
        }

        ol.lst-kix_5j8jfa1lr2qn-3.start {
            counter-reset: lst-ctn-kix_5j8jfa1lr2qn-3 0
        }

        .lst-kix_egh4jwb5e5bq-8>li {
            counter-increment: lst-ctn-kix_egh4jwb5e5bq-8
        }

        .lst-kix_5uxjq0ffbtjv-7>li:before {
            content: "" counter(lst-ctn-kix_5uxjq0ffbtjv-7, lower-latin) ". "
        }

        .lst-kix_5uxjq0ffbtjv-5>li:before {
            content: "" counter(lst-ctn-kix_5uxjq0ffbtjv-5, lower-roman) ". "
        }

        .lst-kix_u7nuao8b0uit-3>li {
            counter-increment: lst-ctn-kix_u7nuao8b0uit-3
        }

        ol.lst-kix_ewhhp7wzm8nf-3.start {
            counter-reset: lst-ctn-kix_ewhhp7wzm8nf-3 0
        }

        ol.lst-kix_u7nuao8b0uit-7.start {
            counter-reset: lst-ctn-kix_u7nuao8b0uit-7 0
        }

        ol.lst-kix_ewhhp7wzm8nf-0.start {
            counter-reset: lst-ctn-kix_ewhhp7wzm8nf-0 0
        }

        .lst-kix_w17famkokbwp-2>li {
            counter-increment: lst-ctn-kix_w17famkokbwp-2
        }

        .lst-kix_a2xpqrabpe6x-1>li {
            counter-increment: lst-ctn-kix_a2xpqrabpe6x-1
        }

        .lst-kix_19dyc6qu4pit-5>li:before {
            content: "" counter(lst-ctn-kix_19dyc6qu4pit-5, lower-roman) ". "
        }

        ol.lst-kix_lr8b0r9upydm-7 {
            list-style-type: none
        }

        ol.lst-kix_lr8b0r9upydm-8 {
            list-style-type: none
        }

        ol.lst-kix_5j8jfa1lr2qn-5.start {
            counter-reset: lst-ctn-kix_5j8jfa1lr2qn-5 0
        }

        .lst-kix_19dyc6qu4pit-3>li:before {
            content: "" counter(lst-ctn-kix_19dyc6qu4pit-3, decimal) ". "
        }

        .lst-kix_19dyc6qu4pit-7>li:before {
            content: "" counter(lst-ctn-kix_19dyc6qu4pit-7, lower-latin) ". "
        }

        .lst-kix_lr8b0r9upydm-8>li {
            counter-increment: lst-ctn-kix_lr8b0r9upydm-8
        }

        .lst-kix_19dyc6qu4pit-1>li:before {
            content: "" counter(lst-ctn-kix_19dyc6qu4pit-1, lower-latin) ". "
        }

        .lst-kix_egh4jwb5e5bq-4>li:before {
            content: "" counter(lst-ctn-kix_egh4jwb5e5bq-4, lower-latin) ". "
        }

        .lst-kix_bjin42889ms0-4>li {
            counter-increment: lst-ctn-kix_bjin42889ms0-4
        }

        ol.lst-kix_19dyc6qu4pit-1.start {
            counter-reset: lst-ctn-kix_19dyc6qu4pit-1 0
        }

        .lst-kix_a2xpqrabpe6x-0>li:before {
            content: "7." counter(lst-ctn-kix_a2xpqrabpe6x-0, decimal) ". "
        }

        .lst-kix_a2xpqrabpe6x-2>li:before {
            content: "" counter(lst-ctn-kix_a2xpqrabpe6x-2, lower-roman) ". "
        }

        .lst-kix_egh4jwb5e5bq-6>li:before {
            content: "" counter(lst-ctn-kix_egh4jwb5e5bq-6, decimal) ". "
        }

        ol.lst-kix_5u6c3bimbh7o-7.start {
            counter-reset: lst-ctn-kix_5u6c3bimbh7o-7 0
        }

        ol.lst-kix_9iardbj9zjtk-7.start {
            counter-reset: lst-ctn-kix_9iardbj9zjtk-7 0
        }

        .lst-kix_egh4jwb5e5bq-8>li:before {
            content: "" counter(lst-ctn-kix_egh4jwb5e5bq-8, lower-roman) ". "
        }

        ol.lst-kix_egh4jwb5e5bq-5.start {
            counter-reset: lst-ctn-kix_egh4jwb5e5bq-5 0
        }

        ol.lst-kix_lr8b0r9upydm-3.start {
            counter-reset: lst-ctn-kix_lr8b0r9upydm-3 0
        }

        .lst-kix_9iardbj9zjtk-3>li:before {
            content: "" counter(lst-ctn-kix_9iardbj9zjtk-3, decimal) ". "
        }

        ol.lst-kix_5uxjq0ffbtjv-0.start {
            counter-reset: lst-ctn-kix_5uxjq0ffbtjv-0 0
        }

        .lst-kix_a2xpqrabpe6x-8>li:before {
            content: "" counter(lst-ctn-kix_a2xpqrabpe6x-8, lower-roman) ". "
        }

        .lst-kix_9iardbj9zjtk-1>li:before {
            content: "" counter(lst-ctn-kix_9iardbj9zjtk-1, lower-latin) ". "
        }

        .lst-kix_a2xpqrabpe6x-8>li {
            counter-increment: lst-ctn-kix_a2xpqrabpe6x-8
        }

        .lst-kix_5u6c3bimbh7o-8>li {
            counter-increment: lst-ctn-kix_5u6c3bimbh7o-8
        }

        .lst-kix_a2xpqrabpe6x-4>li:before {
            content: "" counter(lst-ctn-kix_a2xpqrabpe6x-4, lower-latin) ". "
        }

        .lst-kix_a2xpqrabpe6x-6>li:before {
            content: "" counter(lst-ctn-kix_a2xpqrabpe6x-6, decimal) ". "
        }

        .lst-kix_ewhhp7wzm8nf-6>li {
            counter-increment: lst-ctn-kix_ewhhp7wzm8nf-6
        }

        .lst-kix_9iardbj9zjtk-7>li:before {
            content: "" counter(lst-ctn-kix_9iardbj9zjtk-7, lower-latin) ". "
        }

        ol.lst-kix_w17famkokbwp-6.start {
            counter-reset: lst-ctn-kix_w17famkokbwp-6 0
        }

        .lst-kix_9iardbj9zjtk-5>li:before {
            content: "" counter(lst-ctn-kix_9iardbj9zjtk-5, lower-roman) ". "
        }

        .lst-kix_5j8jfa1lr2qn-8>li {
            counter-increment: lst-ctn-kix_5j8jfa1lr2qn-8
        }

        ol.lst-kix_19dyc6qu4pit-6.start {
            counter-reset: lst-ctn-kix_19dyc6qu4pit-6 0
        }

        .lst-kix_bjin42889ms0-1>li {
            counter-increment: lst-ctn-kix_bjin42889ms0-1
        }

        ol.lst-kix_u7nuao8b0uit-3.start {
            counter-reset: lst-ctn-kix_u7nuao8b0uit-3 0
        }

        ol.lst-kix_5u6c3bimbh7o-8.start {
            counter-reset: lst-ctn-kix_5u6c3bimbh7o-8 0
        }

        ol.lst-kix_5j8jfa1lr2qn-7.start {
            counter-reset: lst-ctn-kix_5j8jfa1lr2qn-7 0
        }

        ol.lst-kix_bjin42889ms0-2.start {
            counter-reset: lst-ctn-kix_bjin42889ms0-2 0
        }

        .lst-kix_lr8b0r9upydm-0>li {
            counter-increment: lst-ctn-kix_lr8b0r9upydm-0
        }

        ol.lst-kix_5u6c3bimbh7o-4 {
            list-style-type: none
        }

        ol.lst-kix_5u6c3bimbh7o-3 {
            list-style-type: none
        }

        ol.lst-kix_5u6c3bimbh7o-2 {
            list-style-type: none
        }

        ol.lst-kix_5u6c3bimbh7o-1 {
            list-style-type: none
        }

        ol.lst-kix_5u6c3bimbh7o-8 {
            list-style-type: none
        }

        ol.lst-kix_5u6c3bimbh7o-7 {
            list-style-type: none
        }

        ol.lst-kix_5u6c3bimbh7o-6 {
            list-style-type: none
        }

        ol.lst-kix_5u6c3bimbh7o-5 {
            list-style-type: none
        }

        ol.lst-kix_5u6c3bimbh7o-0 {
            list-style-type: none
        }

        ol.lst-kix_w17famkokbwp-8.start {
            counter-reset: lst-ctn-kix_w17famkokbwp-8 0
        }

        ol.lst-kix_bjin42889ms0-8.start {
            counter-reset: lst-ctn-kix_bjin42889ms0-8 0
        }

        ol.lst-kix_5uxjq0ffbtjv-4.start {
            counter-reset: lst-ctn-kix_5uxjq0ffbtjv-4 0
        }

        ol.lst-kix_lr8b0r9upydm-7.start {
            counter-reset: lst-ctn-kix_lr8b0r9upydm-7 0
        }

        .lst-kix_egh4jwb5e5bq-2>li:before {
            content: "" counter(lst-ctn-kix_egh4jwb5e5bq-2, lower-roman) ". "
        }

        .lst-kix_egh4jwb5e5bq-1>li:before {
            content: "" counter(lst-ctn-kix_egh4jwb5e5bq-1, lower-latin) ". "
        }

        ol.lst-kix_bjin42889ms0-7.start {
            counter-reset: lst-ctn-kix_bjin42889ms0-7 0
        }

        .lst-kix_5uxjq0ffbtjv-3>li {
            counter-increment: lst-ctn-kix_5uxjq0ffbtjv-3
        }

        ol.lst-kix_5j8jfa1lr2qn-8.start {
            counter-reset: lst-ctn-kix_5j8jfa1lr2qn-8 0
        }

        .lst-kix_lr8b0r9upydm-0>li:before {
            content: "3." counter(lst-ctn-kix_lr8b0r9upydm-0, decimal) ". "
        }

        ol.lst-kix_lr8b0r9upydm-6.start {
            counter-reset: lst-ctn-kix_lr8b0r9upydm-6 0
        }

        .lst-kix_5u6c3bimbh7o-1>li {
            counter-increment: lst-ctn-kix_5u6c3bimbh7o-1
        }

        .lst-kix_egh4jwb5e5bq-4>li {
            counter-increment: lst-ctn-kix_egh4jwb5e5bq-4
        }

        .lst-kix_5j8jfa1lr2qn-6>li {
            counter-increment: lst-ctn-kix_5j8jfa1lr2qn-6
        }

        ol.lst-kix_19dyc6qu4pit-5.start {
            counter-reset: lst-ctn-kix_19dyc6qu4pit-5 0
        }

        .lst-kix_ewhhp7wzm8nf-5>li {
            counter-increment: lst-ctn-kix_ewhhp7wzm8nf-5
        }

        .lst-kix_bjin42889ms0-3>li {
            counter-increment: lst-ctn-kix_bjin42889ms0-3
        }

        .lst-kix_lr8b0r9upydm-7>li:before {
            content: "" counter(lst-ctn-kix_lr8b0r9upydm-7, lower-latin) ". "
        }

        .lst-kix_lr8b0r9upydm-8>li:before {
            content: "" counter(lst-ctn-kix_lr8b0r9upydm-8, lower-roman) ". "
        }

        .lst-kix_lr8b0r9upydm-7>li {
            counter-increment: lst-ctn-kix_lr8b0r9upydm-7
        }

        .lst-kix_lr8b0r9upydm-3>li:before {
            content: "" counter(lst-ctn-kix_lr8b0r9upydm-3, decimal) ". "
        }

        ol.lst-kix_5uxjq0ffbtjv-3.start {
            counter-reset: lst-ctn-kix_5uxjq0ffbtjv-3 0
        }

        .lst-kix_lr8b0r9upydm-4>li:before {
            content: "" counter(lst-ctn-kix_lr8b0r9upydm-4, lower-latin) ". "
        }

        .lst-kix_19dyc6qu4pit-8>li {
            counter-increment: lst-ctn-kix_19dyc6qu4pit-8
        }

        ol.lst-kix_5uxjq0ffbtjv-8.start {
            counter-reset: lst-ctn-kix_5uxjq0ffbtjv-8 0
        }

        .lst-kix_lr8b0r9upydm-5>li {
            counter-increment: lst-ctn-kix_lr8b0r9upydm-5
        }

        .lst-kix_5uxjq0ffbtjv-4>li:before {
            content: "" counter(lst-ctn-kix_5uxjq0ffbtjv-4, lower-latin) ". "
        }

        ol.lst-kix_5uxjq0ffbtjv-5.start {
            counter-reset: lst-ctn-kix_5uxjq0ffbtjv-5 0
        }

        .lst-kix_bjin42889ms0-8>li {
            counter-increment: lst-ctn-kix_bjin42889ms0-8
        }

        ol.lst-kix_lr8b0r9upydm-8.start {
            counter-reset: lst-ctn-kix_lr8b0r9upydm-8 0
        }

        .lst-kix_5uxjq0ffbtjv-8>li:before {
            content: "" counter(lst-ctn-kix_5uxjq0ffbtjv-8, lower-roman) ". "
        }

        .lst-kix_egh4jwb5e5bq-6>li {
            counter-increment: lst-ctn-kix_egh4jwb5e5bq-6
        }

        .lst-kix_w17famkokbwp-0>li {
            counter-increment: lst-ctn-kix_w17famkokbwp-0
        }

        ol.lst-kix_19dyc6qu4pit-7.start {
            counter-reset: lst-ctn-kix_19dyc6qu4pit-7 0
        }

        .lst-kix_5uxjq0ffbtjv-1>li {
            counter-increment: lst-ctn-kix_5uxjq0ffbtjv-1
        }

        ol.lst-kix_bjin42889ms0-4.start {
            counter-reset: lst-ctn-kix_bjin42889ms0-4 0
        }

        ol.lst-kix_bjin42889ms0-3 {
            list-style-type: none
        }

        ol.lst-kix_bjin42889ms0-4 {
            list-style-type: none
        }

        ol.lst-kix_bjin42889ms0-5 {
            list-style-type: none
        }

        ol.lst-kix_bjin42889ms0-6 {
            list-style-type: none
        }

        ol.lst-kix_bjin42889ms0-7 {
            list-style-type: none
        }

        ol.lst-kix_bjin42889ms0-8 {
            list-style-type: none
        }

        ol.lst-kix_u7nuao8b0uit-4.start {
            counter-reset: lst-ctn-kix_u7nuao8b0uit-4 0
        }

        ol.lst-kix_bjin42889ms0-1.start {
            counter-reset: lst-ctn-kix_bjin42889ms0-1 0
        }

        ol.lst-kix_bjin42889ms0-0 {
            list-style-type: none
        }

        ol.lst-kix_bjin42889ms0-1 {
            list-style-type: none
        }

        .lst-kix_a2xpqrabpe6x-4>li {
            counter-increment: lst-ctn-kix_a2xpqrabpe6x-4
        }

        ol.lst-kix_bjin42889ms0-2 {
            list-style-type: none
        }

        ol.lst-kix_ewhhp7wzm8nf-5 {
            list-style-type: none
        }

        ol.lst-kix_ewhhp7wzm8nf-4 {
            list-style-type: none
        }

        .lst-kix_ewhhp7wzm8nf-7>li:before {
            content: "" counter(lst-ctn-kix_ewhhp7wzm8nf-7, lower-latin) ". "
        }

        .lst-kix_19dyc6qu4pit-6>li:before {
            content: "" counter(lst-ctn-kix_19dyc6qu4pit-6, decimal) ". "
        }

        ol.lst-kix_ewhhp7wzm8nf-7 {
            list-style-type: none
        }

        ol.lst-kix_ewhhp7wzm8nf-6 {
            list-style-type: none
        }

        ol.lst-kix_ewhhp7wzm8nf-1 {
            list-style-type: none
        }

        ol.lst-kix_ewhhp7wzm8nf-0 {
            list-style-type: none
        }

        ol.lst-kix_ewhhp7wzm8nf-3 {
            list-style-type: none
        }

        ol.lst-kix_ewhhp7wzm8nf-2 {
            list-style-type: none
        }

        ol.lst-kix_5uxjq0ffbtjv-5 {
            list-style-type: none
        }

        ol.lst-kix_5uxjq0ffbtjv-4 {
            list-style-type: none
        }

        .lst-kix_19dyc6qu4pit-2>li:before {
            content: "" counter(lst-ctn-kix_19dyc6qu4pit-2, lower-roman) ". "
        }

        ol.lst-kix_5uxjq0ffbtjv-7 {
            list-style-type: none
        }

        ol.lst-kix_5uxjq0ffbtjv-6 {
            list-style-type: none
        }

        ol.lst-kix_5uxjq0ffbtjv-1 {
            list-style-type: none
        }

        ol.lst-kix_5uxjq0ffbtjv-0 {
            list-style-type: none
        }

        .lst-kix_u7nuao8b0uit-1>li {
            counter-increment: lst-ctn-kix_u7nuao8b0uit-1
        }

        ol.lst-kix_5uxjq0ffbtjv-3 {
            list-style-type: none
        }

        .lst-kix_egh4jwb5e5bq-5>li:before {
            content: "" counter(lst-ctn-kix_egh4jwb5e5bq-5, lower-roman) ". "
        }

        .lst-kix_bjin42889ms0-4>li:before {
            content: "" counter(lst-ctn-kix_bjin42889ms0-4, lower-latin) ". "
        }

        ol.lst-kix_5uxjq0ffbtjv-2 {
            list-style-type: none
        }

        ol.lst-kix_19dyc6qu4pit-3 {
            list-style-type: none
        }

        .lst-kix_5uxjq0ffbtjv-8>li {
            counter-increment: lst-ctn-kix_5uxjq0ffbtjv-8
        }

        ol.lst-kix_egh4jwb5e5bq-8 {
            list-style-type: none
        }

        .lst-kix_u7nuao8b0uit-6>li {
            counter-increment: lst-ctn-kix_u7nuao8b0uit-6
        }

        ol.lst-kix_19dyc6qu4pit-2 {
            list-style-type: none
        }

        ol.lst-kix_19dyc6qu4pit-1 {
            list-style-type: none
        }

        ol.lst-kix_egh4jwb5e5bq-6 {
            list-style-type: none
        }

        ol.lst-kix_19dyc6qu4pit-0 {
            list-style-type: none
        }

        ol.lst-kix_egh4jwb5e5bq-7 {
            list-style-type: none
        }

        ol.lst-kix_egh4jwb5e5bq-4 {
            list-style-type: none
        }

        ol.lst-kix_5uxjq0ffbtjv-8 {
            list-style-type: none
        }

        ol.lst-kix_egh4jwb5e5bq-5 {
            list-style-type: none
        }

        ol.lst-kix_egh4jwb5e5bq-2 {
            list-style-type: none
        }

        ol.lst-kix_egh4jwb5e5bq-3 {
            list-style-type: none
        }

        ol.lst-kix_egh4jwb5e5bq-0 {
            list-style-type: none
        }

        ol.lst-kix_egh4jwb5e5bq-1 {
            list-style-type: none
        }

        .lst-kix_ewhhp7wzm8nf-3>li:before {
            content: "" counter(lst-ctn-kix_ewhhp7wzm8nf-3, decimal) ". "
        }

        ol.lst-kix_19dyc6qu4pit-8 {
            list-style-type: none
        }

        ol.lst-kix_19dyc6qu4pit-7 {
            list-style-type: none
        }

        ol.lst-kix_19dyc6qu4pit-6 {
            list-style-type: none
        }

        ol.lst-kix_19dyc6qu4pit-5 {
            list-style-type: none
        }

        ol.lst-kix_19dyc6qu4pit-8.start {
            counter-reset: lst-ctn-kix_19dyc6qu4pit-8 0
        }

        .lst-kix_bjin42889ms0-0>li:before {
            content: "" counter(lst-ctn-kix_bjin42889ms0-0, decimal) ". "
        }

        ol.lst-kix_19dyc6qu4pit-4 {
            list-style-type: none
        }

        ol.lst-kix_u7nuao8b0uit-2.start {
            counter-reset: lst-ctn-kix_u7nuao8b0uit-2 0
        }

        .lst-kix_9iardbj9zjtk-2>li:before {
            content: "" counter(lst-ctn-kix_9iardbj9zjtk-2, lower-roman) ". "
        }

        ol.lst-kix_bjin42889ms0-3.start {
            counter-reset: lst-ctn-kix_bjin42889ms0-3 0
        }

        .lst-kix_ewhhp7wzm8nf-3>li {
            counter-increment: lst-ctn-kix_ewhhp7wzm8nf-3
        }

        .lst-kix_a2xpqrabpe6x-3>li:before {
            content: "" counter(lst-ctn-kix_a2xpqrabpe6x-3, decimal) ". "
        }

        .lst-kix_a2xpqrabpe6x-7>li:before {
            content: "" counter(lst-ctn-kix_a2xpqrabpe6x-7, lower-latin) ". "
        }

        ol.lst-kix_5uxjq0ffbtjv-6.start {
            counter-reset: lst-ctn-kix_5uxjq0ffbtjv-6 0
        }

        .lst-kix_5j8jfa1lr2qn-1>li {
            counter-increment: lst-ctn-kix_5j8jfa1lr2qn-1
        }

        .lst-kix_9iardbj9zjtk-6>li:before {
            content: "" counter(lst-ctn-kix_9iardbj9zjtk-6, decimal) ". "
        }

        ol.lst-kix_ewhhp7wzm8nf-8 {
            list-style-type: none
        }

        .lst-kix_bjin42889ms0-8>li:before {
            content: "" counter(lst-ctn-kix_bjin42889ms0-8, lower-roman) ". "
        }

        .lst-kix_9iardbj9zjtk-0>li {
            counter-increment: lst-ctn-kix_9iardbj9zjtk-0
        }

        ol {
            margin: 0;
            padding: 0
        }

        table td,
        table th {
            padding: 0
        }

        .c8 {
            margin-left: 59.5pt;
            padding-top: 12pt;
            padding-left: 25.5pt;
            padding-bottom: 12pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: justify
        }

        .c1 {
            margin-left: 36pt;
            padding-top: 12pt;
            text-indent: -18pt;
            padding-bottom: 12pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: center
        }

        .c6 {
            margin-left: 18pt;
            padding-top: 12pt;
            padding-left: 10.3pt;
            padding-bottom: 12pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: justify
        }

        .c4 {
            margin-left: 10.3pt;
            padding-top: 12pt;
            padding-left: 18pt;
            padding-bottom: 12pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: justify
        }

        .c9 {
            margin-left: 18pt;
            padding-top: 12pt;
            padding-bottom: 12pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: justify
        }

        .c2 {
            color: #000000;
            font-weight: 700;
            text-decoration: none;
            vertical-align: baseline;
            font-size: 14pt;
            font-family: "Inter";
            font-style: normal
        }

        .c10 {
            padding-top: 12pt;
            padding-bottom: 12pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: justify
        }

        .c7 {
            padding-top: 12pt;
            padding-bottom: 12pt;
            line-height: 1.15;
            orphans: 2;
            widows: 2;
            text-align: center
        }

        .c5 {
            color: #000000;
            text-decoration: none;
            vertical-align: baseline;
            font-style: normal
        }

        .c16 {
            font-size: 8pt;
            font-family: "Inter";
            font-weight: 400
        }

        .c14 {
            font-weight: 700;
            font-size: 8pt;
            font-family: "Inter"
        }

        .c19 {
            background-color: #ffffff;
            max-width: 451.4pt;
            padding: 42.5pt 72pt 41.2pt 72pt
        }

        .c15 {
            font-weight: 700;
            font-size: 12pt;
            font-family: "Times New Roman"
        }

        .c11 {
            font-weight: 400;
            font-size: 12pt;
            font-family: "Times New Roman"
        }

        .c23 {
            font-size: 14pt;
            font-family: "Inter";
            font-weight: 700
        }

        .c0 {
            font-size: 12pt;
            font-family: "Inter";
            font-weight: 700
        }

        .c12 {
            font-weight: 400;
            font-size: 7pt;
            font-family: "Inter"
        }

        .c3 {
            font-size: 12pt;
            font-family: "Inter";
            font-weight: 400
        }

        .c20 {
            font-weight: 700;
            font-size: 16pt;
            font-family: "Inter"
        }

        .c13 {
            padding: 0;
            margin: 0
        }

        .c17 {
            margin-left: 36pt;
            padding-left: 0pt
        }

        .c18 {
            height: 11pt
        }

        .c22 {
            text-indent: 35pt
        }

        .c24 {
            margin-left: 72pt
        }

        .c21 {
            margin-left: 40pt
        }

        .title {
            padding-top: 0pt;
            color: #000000;
            font-size: 26pt;
            padding-bottom: 3pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        .subtitle {
            padding-top: 0pt;
            color: #666666;
            font-size: 15pt;
            padding-bottom: 16pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        li {
            color: #000000;
            font-size: 11pt;
            font-family: "Arial"
        }

        p {
            margin: 0;
            color: #000000;
            font-size: 11pt;
            font-family: "Arial"
        }

        h1 {
            padding-top: 20pt;
            color: #000000;
            font-size: 20pt;
            padding-bottom: 6pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h2 {
            padding-top: 18pt;
            color: #000000;
            font-size: 16pt;
            padding-bottom: 6pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h3 {
            padding-top: 16pt;
            color: #434343;
            font-size: 14pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h4 {
            padding-top: 14pt;
            color: #666666;
            font-size: 12pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h5 {
            padding-top: 12pt;
            color: #666666;
            font-size: 11pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h6 {
            padding-top: 12pt;
            color: #666666;
            font-size: 11pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.15;
            page-break-after: avoid;
            font-style: italic;
            orphans: 2;
            widows: 2;
            text-align: left
        }
    </style>
</head>

<body class="c19">
    <p class="c7"><span class="c5 c20">&#1055;&#1091;&#1073;&#1083;&#1080;&#1095;&#1085;&#1072;&#1103; &#1086;&#1092;&#1077;&#1088;&#1090;&#1072; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072; &laquo;any.market&raquo; &#1076;&#1083;&#1103; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1074;</span></p>
    <p
        class="c7 c18"><span class="c5 c20"></span></p>
        <p class="c10"><span class="c3">&#1048;&#1085;&#1090;&#1077;&#1088;&#1085;&#1077;&#1090;-&#1087;&#1083;&#1086;&#1097;&#1072;&#1076;&#1082;&#1072; &laquo;</span><span class="c0">any.market</span><span class="c3">&raquo; &#1074; &#1083;&#1080;&#1094;&#1077; &#1048;&#1085;&#1076;&#1080;&#1074;&#1080;&#1076;&#1091;&#1072;&#1083;&#1100;&#1085;&#1086;&#1075;&#1086; &#1087;&#1088;&#1077;&#1076;&#1087;&#1088;&#1080;&#1085;&#1080;&#1084;&#1072;&#1090;&#1077;&#1083;&#1103; </span>
            <span
                class="c0">&#1041;&#1088;&#1072;&#1094;&#1091;&#1085; &#1040;&#1085;&#1085;&#1099; &#1057;&#1077;&#1088;&#1075;&#1077;&#1077;&#1074;&#1085;&#1099;</span><span class="c3">&nbsp;(&#1048;&#1053;&#1053; 616608081864, &#1054;&#1043;&#1056;&#1053;&#1048;&#1055; 320619600119490), &#1080;&#1084;&#1077;&#1085;&#1091;&#1077;&#1084;&#1072;&#1103; &#1074; &#1076;&#1072;&#1083;&#1100;&#1085;&#1077;&#1081;&#1096;&#1077;&#1084; &laquo;&#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&raquo;, &#1072; &#1090;&#1072;&#1082;&#1078;&#1077; </span>
                <span
                    class="c0">&#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1077;&#1094;</span><span class="c3 c5">&nbsp;&#1079;&#1072;&#1082;&#1083;&#1102;&#1095;&#1080;&#1083;&#1080; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1077; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1077; &#1085;&#1072; &#1089;&#1083;&#1077;&#1076;&#1091;&#1102;&#1097;&#1080;&#1093; &#1091;&#1089;&#1083;&#1086;&#1074;&#1080;&#1103;&#1093;:</span></p>
        <p
            class="c10 c18"><span class="c5 c3"></span></p>
            <p class="c7"><span class="c2">&#1058;&#1077;&#1088;&#1084;&#1080;&#1085;&#1099;</span></p>
            <p class="c10"><span class="c0">&#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1072; / &#1057;&#1072;&#1081;&#1090; </span><span class="c5 c3">&nbsp;- &#1074;&#1077;&#1073;-&#1089;&#1072;&#1081;&#1090; any.market, &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1103;&#1102;&#1097;&#1080;&#1081; &#1076;&#1086;&#1089;&#1090;&#1091;&#1087; &#1082; &#1073;&#1072;&#1079;&#1077; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1086;&#1085;&#1085;&#1086;-&#1089;&#1087;&#1088;&#1072;&#1074;&#1086;&#1095;&#1085;&#1086;&#1081; &#1089;&#1080;&#1089;&#1090;&#1077;&#1084;&#1077;, &#1087;&#1088;&#1077;&#1076;&#1085;&#1072;&#1079;&#1085;&#1072;&#1095;&#1077;&#1085;&#1085;&#1072;&#1103; &#1076;&#1083;&#1103; &#1088;&#1072;&#1079;&#1084;&#1077;&#1097;&#1077;&#1085;&#1080;&#1103; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072;&#1084;&#1080; &#1058;&#1086;&#1074;&#1072;&#1088;&#1085;&#1099;&#1093; &#1055;&#1088;&#1077;&#1076;&#1083;&#1086;&#1078;&#1077;&#1085;&#1080;&#1081; &#1085;&#1072; &#1057;&#1072;&#1081;&#1090;&#1077;, &#1072; &#1090;&#1072;&#1082;&#1078;&#1077; &#1076;&#1083;&#1103; &#1091;&#1095;&#1077;&#1090;&#1072; &#1076;&#1077;&#1081;&#1089;&#1090;&#1074;&#1080;&#1081; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1086;&#1074; &#1074; &#1089;&#1074;&#1103;&#1079;&#1080; &#1089; &#1086;&#1092;&#1086;&#1088;&#1084;&#1083;&#1077;&#1085;&#1080;&#1077;&#1084; &#1047;&#1072;&#1082;&#1072;&#1079;&#1086;&#1074; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1072;&#1084;&#1080; &#1085;&#1072; &#1087;&#1088;&#1080;&#1086;&#1073;&#1088;&#1077;&#1090;&#1077;&#1085;&#1080;&#1077; &#1058;&#1086;&#1074;&#1072;&#1088;&#1086;&#1074; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072;</span></p>
            <p
                class="c10"><span class="c0">&#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1077;&#1094; </span><span class="c5 c3">- &#1102;&#1088;&#1080;&#1076;&#1080;&#1095;&#1077;&#1089;&#1082;&#1086;&#1077; &#1083;&#1080;&#1094;&#1086; &#1080;&#1083;&#1080; &#1080;&#1085;&#1076;&#1080;&#1074;&#1080;&#1076;&#1091;&#1072;&#1083;&#1100;&#1085;&#1099;&#1081; &#1087;&#1088;&#1077;&#1076;&#1087;&#1088;&#1080;&#1085;&#1080;&#1084;&#1072;&#1090;&#1077;&#1083;&#1100;, &#1079;&#1072;&#1088;&#1077;&#1075;&#1080;&#1089;&#1090;&#1088;&#1080;&#1088;&#1086;&#1074;&#1072;&#1085;&#1085;&#1099;&#1077; &#1074; &#1091;&#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1083;&#1077;&#1085;&#1085;&#1086;&#1084; &#1087;&#1086;&#1088;&#1103;&#1076;&#1082;&#1077; &#1085;&#1072; &#1090;&#1077;&#1088;&#1088;&#1080;&#1090;&#1086;&#1088;&#1080;&#1080; &#1056;&#1086;&#1089;&#1089;&#1080;&#1081;&#1089;&#1082;&#1086;&#1081; &#1060;&#1077;&#1076;&#1077;&#1088;&#1072;&#1094;&#1080;&#1080;, &#1079;&#1072;&#1088;&#1077;&#1075;&#1080;&#1089;&#1090;&#1088;&#1080;&#1088;&#1086;&#1074;&#1072;&#1085;&#1085;&#1099;&#1081; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077; &#1076;&#1083;&#1103; &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1077;&#1085;&#1080;&#1103; &#1058;&#1086;&#1074;&#1072;&#1088;&#1085;&#1099;&#1093; &#1087;&#1088;&#1077;&#1076;&#1083;&#1086;&#1078;&#1077;&#1085;&#1080;&#1081;;</span></p>
                <p
                    class="c10"><span class="c0">&#1055;&#1086;&#1082;&#1091;&#1087;&#1072;&#1090;&#1077;&#1083;&#1100; (&#1050;&#1083;&#1080;&#1077;&#1085;&#1090;) - </span><span class="c5 c3">&#1092;&#1080;&#1079;&#1080;&#1095;&#1077;&#1089;&#1082;&#1086;&#1077; &#1083;&#1080;&#1094;&#1086;, &#1074; &#1091;&#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1083;&#1077;&#1085;&#1085;&#1086;&#1084; &#1087;&#1086;&#1088;&#1103;&#1076;&#1082;&#1077; &#1079;&#1072;&#1088;&#1077;&#1075;&#1080;&#1089;&#1090;&#1088;&#1080;&#1088;&#1086;&#1074;&#1072;&#1085;&#1085;&#1086;&#1077; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077;, &#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1091;&#1102;&#1097;&#1077;&#1077; &#1059;&#1089;&#1083;&#1086;&#1074;&#1080;&#1103; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1099;, &#1088;&#1072;&#1079;&#1084;&#1077;&#1097;&#1072;&#1102;&#1097;&#1077;&#1077; &#1047;&#1072;&#1082;&#1072;&#1079;&#1099; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077;, &#1080;&#1089;&#1082;&#1083;&#1102;&#1095;&#1080;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086; &#1076;&#1083;&#1103; &#1083;&#1080;&#1095;&#1085;&#1099;&#1093;, &#1089;&#1077;&#1084;&#1077;&#1081;&#1085;&#1099;&#1093;, &#1076;&#1086;&#1084;&#1072;&#1096;&#1085;&#1080;&#1093; &#1080; &#1080;&#1085;&#1099;&#1093; &#1085;&#1091;&#1078;&#1076;, &#1085;&#1077; &#1089;&#1074;&#1103;&#1079;&#1072;&#1085;&#1085;&#1099;&#1093; &#1089; &#1086;&#1089;&#1091;&#1097;&#1077;&#1089;&#1090;&#1074;&#1083;&#1077;&#1085;&#1080;&#1077;&#1084; &#1087;&#1088;&#1077;&#1076;&#1087;&#1088;&#1080;&#1085;&#1080;&#1084;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1082;&#1086;&#1081; &#1076;&#1077;&#1103;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086;&#1089;&#1090;&#1080;.</span></p>
                    <p
                        class="c10"><span class="c0">&#1058;&#1086;&#1074;&#1072;&#1088; (&#1058;&#1086;&#1074;&#1072;&#1088;&#1099;)</span><span class="c5 c3">&nbsp;- &#1090;&#1086;&#1074;&#1072;&#1088;&#1099;, &#1103;&#1074;&#1083;&#1103;&#1102;&#1097;&#1080;&#1077;&#1089;&#1103; &#1087;&#1088;&#1077;&#1076;&#1084;&#1077;&#1090;&#1086;&#1084; &#1089;&#1076;&#1077;&#1083;&#1086;&#1082;, &#1079;&#1072;&#1082;&#1083;&#1102;&#1095;&#1072;&#1077;&#1084;&#1099;&#1093; &#1084;&#1077;&#1078;&#1076;&#1091; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1080; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1086;&#1084;. &#1042;&#1089;&#1077; &#1087;&#1088;&#1072;&#1074;&#1086;&#1086;&#1090;&#1085;&#1086;&#1096;&#1077;&#1085;&#1080;&#1103;, &#1074;&#1086;&#1079;&#1085;&#1080;&#1082;&#1072;&#1102;&#1097;&#1080;&#1077; &#1087;&#1086; &#1087;&#1086;&#1074;&#1086;&#1076;&#1091; &#1076;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1086;&#1074; &#1084;&#1077;&#1078;&#1076;&#1091; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1080; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1086;&#1084; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077; &#1074;&#1086;&#1079;&#1085;&#1080;&#1082;&#1072;&#1102;&#1090; &#1084;&#1077;&#1078;&#1076;&#1091; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1080; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1086;&#1084;, &#1057;&#1077;&#1088;&#1074;&#1080;&#1089; &#1087;&#1086; &#1091;&#1082;&#1072;&#1079;&#1072;&#1085;&#1085;&#1099;&#1084; &#1089;&#1076;&#1077;&#1083;&#1082;&#1072;&#1084; &#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1077;&#1085;&#1085;&#1086;&#1089;&#1090;&#1080; &#1085;&#1077; &#1085;&#1077;&#1089;&#1077;&#1090;.</span></p>
                        <p
                            class="c10"><span class="c0">&#1051;&#1080;&#1095;&#1085;&#1099;&#1081; &#1082;&#1072;&#1073;&#1080;&#1085;&#1077;&#1090; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072;</span><span class="c5 c3">&nbsp;&ndash; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1072;&#1103; &#1089;&#1090;&#1088;&#1072;&#1085;&#1080;&#1094;&#1072; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077;, &#1089;&#1086;&#1076;&#1077;&#1088;&#1078;&#1072;&#1097;&#1072;&#1103; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1086;&#1085;&#1085;&#1099;&#1077; &#1076;&#1072;&#1085;&#1085;&#1099;&#1077; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072;, &#1074;&#1082;&#1083;&#1102;&#1095;&#1072;&#1103; &#1102;&#1088;&#1080;&#1076;&#1080;&#1095;&#1077;&#1089;&#1082;&#1091;&#1102; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1102; &#1086; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1077;, &#1073;&#1072;&#1085;&#1082;&#1086;&#1074;&#1089;&#1082;&#1080;&#1077; &#1088;&#1077;&#1082;&#1074;&#1080;&#1079;&#1080;&#1090;&#1099;, &#1082;&#1086;&#1085;&#1090;&#1072;&#1082;&#1090;&#1085;&#1099;&#1077; &#1076;&#1072;&#1085;&#1085;&#1099;&#1077; &#1080; &#1086;&#1073;&#1097;&#1080;&#1077; &#1089;&#1074;&#1077;&#1076;&#1077;&#1085;&#1080;&#1103;, &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1102; &#1086; &#1058;&#1086;&#1074;&#1072;&#1088;&#1072;&#1093; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072;, &#1088;&#1072;&#1079;&#1084;&#1077;&#1097;&#1072;&#1077;&#1084;&#1099;&#1093; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077; &#1080; &#1047;&#1072;&#1082;&#1072;&#1079;&#1072;&#1093; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1086;&#1074; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072;, &#1072; &#1090;&#1072;&#1082;&#1078;&#1077; &#1059;&#1074;&#1077;&#1076;&#1086;&#1084;&#1083;&#1077;&#1085;&#1080;&#1103;. </span></p>
                            <p
                                class="c10 c18"><span class="c5 c3"></span></p>
                                <p class="c10 c22"><span class="c5 c15">&nbsp;</span></p>
                                <p class="c10 c18 c22"><span class="c5 c15"></span></p>
                                <ol class="c13 lst-kix_bjin42889ms0-0 start" start="1">
                                    <li class="c7 c17"><span class="c23">&#1054;&#1073;&#1097;&#1080;&#1077; &#1087;&#1086;&#1083;&#1086;&#1078;&#1077;&#1085;&#1080;&#1103;</span></li>
                                </ol>
                                <ol class="c13 lst-kix_u7nuao8b0uit-0 start" start="1">
                                    <li class="c6"><span class="c5 c3">&#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1072; &#1103;&#1074;&#1083;&#1103;&#1077;&#1090;&#1089;&#1103; &#1089;&#1086;&#1073;&#1089;&#1090;&#1074;&#1077;&#1085;&#1085;&#1086;&#1089;&#1090;&#1100;&#1102; &#1048;&#1055; &#1041;&#1088;&#1072;&#1094;&#1091;&#1085; &#1040;&#1085;&#1085;&#1099; &#1057;&#1077;&#1088;&#1075;&#1077;&#1077;&#1074;&#1085;&#1099;.</span></li>
                                    <li
                                        class="c6"><span class="c5 c3">&#1053;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1077; &#1089;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1077; &#1088;&#1077;&#1075;&#1091;&#1083;&#1080;&#1088;&#1091;&#1077;&#1090;&#1089;&#1103; &#1085;&#1086;&#1088;&#1084;&#1072;&#1084;&#1080; &#1089;&#1090;. 428 &#1043;&#1050; &#1056;&#1060; &#1086; &#1076;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1077; &#1087;&#1088;&#1080;&#1089;&#1086;&#1077;&#1076;&#1080;&#1085;&#1077;&#1085;&#1080;&#1103;. &#1056;&#1077;&#1075;&#1080;&#1089;&#1090;&#1088;&#1080;&#1088;&#1091;&#1103;&#1089;&#1100; &#1080; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1091;&#1103; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1091;, &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100; &#1075;&#1072;&#1088;&#1072;&#1085;&#1090;&#1080;&#1088;&#1091;&#1077;&#1090;, &#1095;&#1090;&#1086; &#1086;&#1079;&#1085;&#1072;&#1082;&#1086;&#1084;&#1083;&#1077;&#1085; &#1080; &#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1077;&#1085; &#1089; &#1091;&#1089;&#1083;&#1086;&#1074;&#1080;&#1103;&#1084;&#1080; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1075;&#1086; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103;.</span></li>
                                        <li
                                            class="c6"><span class="c5 c3">&#1055;&#1086;&#1083;&#1100;&#1079;&#1091;&#1103;&#1089;&#1100; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1086;&#1084;, &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1100; &#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1091;&#1077;&#1090; &#1059;&#1089;&#1083;&#1086;&#1074;&#1080;&#1103; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103; &#1089;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072; &#1080; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1077; &#1086;&#1073; &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1077; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093;.</span></li>
                                            <li
                                                class="c6"><span class="c5 c3">&#1057;&#1077;&#1088;&#1074;&#1080;&#1089; &#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1103;&#1077;&#1090; &#1079;&#1072; &#1089;&#1086;&#1073;&#1086;&#1081; &#1087;&#1088;&#1072;&#1074;&#1086; &#1074;&#1085;&#1086;&#1089;&#1080;&#1090;&#1100; &#1080;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1103; &#1074; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1077; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1077; &#1080; &#1087;&#1088;&#1080;&#1083;&#1086;&#1078;&#1077;&#1085;&#1080;&#1103; &#1082; &#1085;&#1077;&#1084;&#1091; &#1087;&#1088;&#1080; &#1091;&#1089;&#1083;&#1086;&#1074;&#1080;&#1080; &#1085;&#1072;&#1087;&#1088;&#1072;&#1074;&#1083;&#1077;&#1085;&#1080;&#1103; &#1074; &#1051;&#1080;&#1095;&#1085;&#1099;&#1081; &#1050;&#1072;&#1073;&#1080;&#1085;&#1077;&#1090; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072; &#1091;&#1074;&#1077;&#1076;&#1086;&#1084;&#1083;&#1077;&#1085;&#1080;&#1103; &#1085;&#1077; &#1087;&#1086;&#1079;&#1076;&#1085;&#1077;&#1077; &#1095;&#1077;&#1084; &#1079;&#1072; 14 (&#1063;&#1077;&#1090;&#1099;&#1088;&#1085;&#1072;&#1076;&#1094;&#1072;&#1090;&#1100;) &#1082;&#1072;&#1083;&#1077;&#1085;&#1076;&#1072;&#1088;&#1085;&#1099;&#1093; &#1076;&#1085;&#1077;&#1081; &#1076;&#1086; &#1076;&#1072;&#1090;&#1099; &#1074;&#1089;&#1090;&#1091;&#1087;&#1083;&#1077;&#1085;&#1080;&#1103; &#1074; &#1089;&#1080;&#1083;&#1091; &#1091;&#1082;&#1072;&#1079;&#1072;&#1085;&#1085;&#1099;&#1093; &#1080;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1081;. &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1077;&#1094; &#1086;&#1073;&#1103;&#1079;&#1091;&#1077;&#1090;&#1089;&#1103; &#1088;&#1077;&#1075;&#1091;&#1083;&#1103;&#1088;&#1085;&#1086; &#1086;&#1090;&#1089;&#1083;&#1077;&#1078;&#1080;&#1074;&#1072;&#1090;&#1100; &#1080;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1103; &#1074; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1080; &#1080; &#1087;&#1088;&#1080;&#1083;&#1086;&#1078;&#1077;&#1085;&#1080;&#1103;&#1093;, &#1090;&#1077;&#1082;&#1089;&#1090; &#1082;&#1086;&#1090;&#1086;&#1088;&#1099;&#1093; &#1076;&#1086;&#1089;&#1090;&#1091;&#1087;&#1077;&#1085; &#1077;&#1084;&#1091; &#1074; &#1051;&#1080;&#1095;&#1085;&#1086;&#1084; &#1082;&#1072;&#1073;&#1080;&#1085;&#1077;&#1090;&#1077; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077;.</span></li>
                                                <li
                                                    class="c6"><span class="c5 c3">&#1057;&#1077;&#1088;&#1074;&#1080;&#1089; &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1103;&#1077;&#1090; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1091; &#1073;&#1077;&#1089;&#1087;&#1083;&#1072;&#1090;&#1085;&#1091;&#1102; &#1074;&#1086;&#1079;&#1084;&#1086;&#1078;&#1085;&#1086;&#1089;&#1090;&#1100; &#1087;&#1086;&#1080;&#1089;&#1082;&#1072; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080; &#1086; &#1058;&#1086;&#1074;&#1072;&#1088;&#1072;&#1093;, &#1086;&#1079;&#1085;&#1072;&#1082;&#1086;&#1084;&#1083;&#1077;&#1085;&#1080;&#1103; &#1089; &#1090;&#1086;&#1074;&#1072;&#1088;&#1085;&#1099;&#1084;&#1080; &#1087;&#1088;&#1077;&#1076;&#1083;&#1086;&#1078;&#1077;&#1085;&#1080;&#1103;&#1084;&#1080; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1074;, &#1086;&#1076;&#1085;&#1072;&#1082;&#1086; &#1085;&#1077; &#1103;&#1074;&#1083;&#1103;&#1077;&#1090;&#1089;&#1103; &#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1077;&#1085;&#1085;&#1086;&#1081; &#1089;&#1090;&#1086;&#1088;&#1086;&#1085;&#1086;&#1081; &#1087;&#1086; &#1089;&#1076;&#1077;&#1083;&#1082;&#1072;&#1084; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1086;&#1074; &#1089; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072;&#1084;&#1080;.</span></li>
                                                    <li
                                                        class="c6"><span class="c5 c3">&#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1077;&#1094; &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1103;&#1077;&#1090; &#1087;&#1086;&#1083;&#1085;&#1091;&#1102; &#1080; &#1076;&#1086;&#1089;&#1090;&#1086;&#1074;&#1077;&#1088;&#1085;&#1091;&#1102; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1102; &#1086; &#1058;&#1086;&#1074;&#1072;&#1088;&#1077;, &#1059;&#1089;&#1083;&#1091;&#1075;&#1072;&#1093;, &#1074;&#1082;&#1083;&#1102;&#1095;&#1072;&#1103; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1102; &#1086;&#1073; &#1086;&#1089;&#1085;&#1086;&#1074;&#1085;&#1099;&#1093; &#1087;&#1086;&#1090;&#1088;&#1077;&#1073;&#1080;&#1090;&#1077;&#1083;&#1100;&#1089;&#1082;&#1080;&#1093; &#1089;&#1074;&#1086;&#1081;&#1089;&#1090;&#1074;&#1072;&#1093; &#1058;&#1086;&#1074;&#1072;&#1088;&#1072; &#1080; &#1084;&#1077;&#1089;&#1090;&#1077; &#1077;&#1075;&#1086; &#1080;&#1079;&#1075;&#1086;&#1090;&#1086;&#1074;&#1083;&#1077;&#1085;&#1080;&#1103;. &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1077;&#1094; &#1075;&#1072;&#1088;&#1072;&#1085;&#1090;&#1080;&#1088;&#1091;&#1077;&#1090; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1091; &#1082;&#1072;&#1095;&#1077;&#1089;&#1090;&#1074;&#1086; &#1090;&#1086;&#1074;&#1072;&#1088;&#1072; &#1080; &#1086;&#1090;&#1074;&#1077;&#1095;&#1072;&#1077;&#1090; &#1087;&#1086; &#1074;&#1089;&#1077;&#1084; &#1090;&#1088;&#1077;&#1073;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103;&#1084; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1086;&#1074; &#1087;&#1086; &#1082;&#1072;&#1095;&#1077;&#1089;&#1090;&#1074;&#1091; &#1058;&#1086;&#1074;&#1072;&#1088;&#1072;.</span></li>
                                </ol>
                                <p class="c1"><span class="c2">2. &#1062;&#1077;&#1085;&#1099; &#1080; &#1087;&#1086;&#1088;&#1103;&#1076;&#1086;&#1082; &#1088;&#1072;&#1089;&#1095;&#1105;&#1090;&#1086;&#1074;</span></p>
                                <ol class="c13 lst-kix_9iardbj9zjtk-0 start"
                                    start="1">
                                    <li class="c6"><span class="c5 c3">&#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1077;&#1094; &#1074;&#1087;&#1088;&#1072;&#1074;&#1077; &#1074; &#1086;&#1076;&#1085;&#1086;&#1089;&#1090;&#1086;&#1088;&#1086;&#1085;&#1085;&#1077;&#1084; &#1087;&#1086;&#1088;&#1103;&#1076;&#1082;&#1077; &#1091;&#1089;&#1090;&#1072;&#1085;&#1072;&#1074;&#1083;&#1080;&#1074;&#1072;&#1090;&#1100; &#1094;&#1077;&#1085;&#1099; &#1085;&#1072; &#1074;&#1099;&#1089;&#1090;&#1072;&#1074;&#1083;&#1103;&#1077;&#1084;&#1099;&#1077; &#1080;&#1084; &#1058;&#1086;&#1074;&#1072;&#1088;&#1099;.</span></li>
                                    <li
                                        class="c6"><span class="c3">&#1062;&#1077;&#1085;&#1099; &#1085;&#1072; &#1090;&#1086;&#1074;&#1072;&#1088;&#1099; &#1091;&#1089;&#1090;&#1072;&#1085;&#1072;&#1074;&#1083;&#1080;&#1074;&#1072;&#1102;&#1090;&#1089;&#1103; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1085;&#1072; &#1089;&#1090;&#1088;&#1072;&#1085;&#1080;&#1094;&#1077; &#1084;&#1072;&#1075;&#1072;&#1079;&#1080;&#1085;&#1072; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072; &#1095;&#1077;&#1088;&#1077;&#1079; &#1051;&#1080;&#1095;&#1085;&#1099;&#1081; &#1082;&#1072;&#1073;&#1080;&#1085;&#1077;&#1090; </span>
                                        <span
                                            class="c3">&#1080;&#1083;&#1080; &#1076;&#1086;&#1074;&#1086;&#1076;&#1103;&#1090;&#1089;&#1103; &#1076;&#1086; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1072; &#1080;&#1085;&#1099;&#1084; &#1087;&#1086;&#1085;&#1103;&#1090;&#1085;&#1099;&#1084;
                                            &#1089;&#1087;&#1086;&#1089;&#1086;&#1073;&#1086;&#1084;.</span>
                                            </li>
                                            <li class="c6"><span class="c5 c3">&#1056;&#1072;&#1089;&#1095;&#1077;&#1090;&#1099; &#1084;&#1077;&#1078;&#1076;&#1091; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1080; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1086;&#1084; &#1079;&#1072; &#1058;&#1086;&#1074;&#1072;&#1088; &#1087;&#1088;&#1086;&#1080;&#1079;&#1074;&#1086;&#1076;&#1103;&#1090;&#1089;&#1103; &#1083;&#1102;&#1073;&#1099;&#1084; &#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1086;&#1074;&#1072;&#1085;&#1085;&#1099;&#1084; &#1089;&#1090;&#1086;&#1088;&#1086;&#1085;&#1072;&#1084;&#1080; &#1079;&#1072;&#1082;&#1086;&#1085;&#1085;&#1099;&#1084; &#1089;&#1087;&#1086;&#1089;&#1086;&#1073;&#1086;&#1084;.</span></li>
                                            <li
                                                class="c6"><span class="c3">&#1042;&#1099;&#1073;&#1086;&#1088; &#1089;&#1086;&#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1091;&#1102;&#1097;&#1077;&#1081; &#1092;&#1086;&#1088;&#1084;&#1099; &#1086;&#1087;&#1083;&#1072;&#1090;&#1099; &#1087;&#1088;&#1086;&#1080;&#1079;&#1074;&#1086;&#1076;&#1080;&#1090;&#1089;&#1103; &#1055;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1077;&#1083;&#1077;&#1084; &#1074; &#1080;&#1085;&#1090;&#1077;&#1088;&#1092;&#1077;&#1081;&#1089;&#1077; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1099; &#1080;&#1079; &#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1086;&#1074;&#1072;&#1085;&#1085;&#1099;&#1093; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; </span>
                                                <span
                                                    class="c3">&#1080; &#1087;&#1086;&#1076;&#1090;&#1074;&#1077;&#1088;&#1078;&#1076;&#1077;&#1085;&#1085;&#1099;&#1084; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077;.</span>
                                                    </li>
                                                    <li class="c6"><span class="c3">&#1050;&#1083;&#1080;&#1077;&#1085;&#1090; &#1080;&#1079;&#1074;&#1077;&#1097;&#1072;&#1077;&#1090;&#1089;&#1103; &#1086; &#1089;&#1090;&#1086;&#1080;&#1084;&#1086;&#1089;&#1090;&#1080; &#1080; &#1089;&#1087;&#1086;&#1089;&#1086;&#1073;&#1077; &#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1082;&#1080; &#1058;&#1086;&#1074;&#1072;&#1088;&#1072; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1085;&#1072; &#1089;&#1090;&#1088;&#1072;&#1085;&#1080;&#1094;&#1077; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077; </span>
                                                        <span
                                                            class="c3">&#1080;&#1083;&#1080; &#1080;&#1085;&#1099;&#1084; &#1087;&#1086;&#1085;&#1103;&#1090;&#1085;&#1099;&#1084; &#1089;&#1087;&#1086;&#1089;&#1086;&#1073;&#1086;&#1084;.</span>
                                                    </li>
                                                    <li class="c6"><span class="c5 c3">&#1057;&#1077;&#1088;&#1074;&#1080;&#1089; &#1085;&#1077; &#1103;&#1074;&#1083;&#1103;&#1077;&#1090;&#1089;&#1103; &#1089;&#1090;&#1086;&#1088;&#1086;&#1085;&#1086;&#1081; &#1089;&#1076;&#1077;&#1083;&#1082;&#1080;, &#1085;&#1077; &#1091;&#1095;&#1072;&#1089;&#1090;&#1074;&#1091;&#1077;&#1090; &#1074; &#1088;&#1072;&#1089;&#1095;&#1077;&#1090;&#1072;&#1093; &#1089;&#1090;&#1086;&#1088;&#1086;&#1085; &#1080; &#1085;&#1077; &#1103;&#1074;&#1083;&#1103;&#1077;&#1090;&#1089;&#1103; &#1087;&#1083;&#1072;&#1090;&#1077;&#1078;&#1085;&#1099;&#1084; &#1072;&#1075;&#1077;&#1085;&#1090;&#1086;&#1084; &#1087;&#1088;&#1080; &#1087;&#1088;&#1086;&#1074;&#1077;&#1076;&#1077;&#1085;&#1080;&#1080; &#1088;&#1072;&#1089;&#1095;&#1077;&#1090;&#1086;&#1074; &#1074; &#1089;&#1086;&#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1080;&#1080; &#1089; &#1087;. 5.2 &#1059;&#1089;&#1083;&#1086;&#1074;&#1080;&#1081; &#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1085;&#1086; &#1089; &#1087;&#1087;. 1, 4 &#1095;. 2 &#1089;&#1090;. 1 &#1060;&#1077;&#1076;&#1077;&#1088;&#1072;&#1083;&#1100;&#1085;&#1086;&#1075;&#1086; &#1079;&#1072;&#1082;&#1086;&#1085;&#1072; &#1086;&#1090; 03.06.2009 N 103-&#1060;&#1047; &laquo;&#1054; &#1076;&#1077;&#1103;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086;&#1089;&#1090;&#1080; &#1087;&#1086; &#1087;&#1088;&#1080;&#1077;&#1084;&#1091; &#1087;&#1083;&#1072;&#1090;&#1077;&#1078;&#1077;&#1081; &#1092;&#1080;&#1079;&#1080;&#1095;&#1077;&#1089;&#1082;&#1080;&#1093; &#1083;&#1080;&#1094;, &#1086;&#1089;&#1091;&#1097;&#1077;&#1089;&#1090;&#1074;&#1083;&#1103;&#1077;&#1084;&#1086;&#1081; &#1087;&#1083;&#1072;&#1090;&#1077;&#1078;&#1085;&#1099;&#1084;&#1080; &#1072;&#1075;&#1077;&#1085;&#1090;&#1072;&#1084;&#1080;&raquo;.</span></li>
                                                    <li
                                                        class="c6"><span class="c5 c3">&#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1077;&#1094; &#1075;&#1072;&#1088;&#1072;&#1085;&#1090;&#1080;&#1088;&#1091;&#1077;&#1090; &#1074;&#1086;&#1079;&#1084;&#1086;&#1078;&#1085;&#1086;&#1089;&#1090;&#1100; &#1086;&#1089;&#1091;&#1097;&#1077;&#1089;&#1090;&#1074;&#1083;&#1077;&#1085;&#1080;&#1103; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1072;&#1084;&#1080; &#1073;&#1077;&#1079;&#1085;&#1072;&#1083;&#1080;&#1095;&#1085;&#1099;&#1093; &#1088;&#1072;&#1089;&#1095;&#1105;&#1090;&#1086;&#1074; &#1087;&#1086;&#1089;&#1088;&#1077;&#1076;&#1089;&#1090;&#1074;&#1072;&#1084; &#1089;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072; &laquo;&#1071;&#1085;&#1076;&#1077;&#1082;&#1089;.&#1050;&#1072;&#1089;&#1089;&#1072;&raquo;/</span></li>
                                                        <li
                                                            class="c6"><span class="c5 c3">&#1057;&#1077;&#1088;&#1074;&#1080;&#1089; &#1085;&#1077; &#1103;&#1074;&#1083;&#1103;&#1077;&#1090;&#1089;&#1103; &#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1077;&#1085;&#1085;&#1099;&#1084; &#1083;&#1080;&#1094;&#1086;&#1084; &#1087;&#1086; &#1087;&#1083;&#1072;&#1090;&#1077;&#1078;&#1085;&#1099;&#1084; &#1090;&#1088;&#1072;&#1085;&#1079;&#1072;&#1082;&#1094;&#1080;&#1103;&#1084;, &#1087;&#1088;&#1086;&#1080;&#1079;&#1074;&#1086;&#1076;&#1080;&#1084;&#1099;&#1084; &#1084;&#1077;&#1078;&#1076;&#1091; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1072;&#1084;&#1080; &#1080; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072;&#1084;&#1080; &#1085;&#1080; &#1087;&#1088;&#1080; &#1082;&#1072;&#1082;&#1080;&#1093; &#1091;&#1089;&#1083;&#1086;&#1074;&#1080;&#1103;&#1093;.</span></li>
                                </ol>
                                <p class="c9"><span class="c5 c11">&nbsp;</span></p>
                                <p class="c1"><span class="c2">3. &#1042;&#1086;&#1079;&#1085;&#1072;&#1075;&#1088;&#1072;&#1078;&#1076;&#1077;&#1085;&#1080;&#1077; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072;</span></p>
                                <ol class="c13 lst-kix_lr8b0r9upydm-0 start"
                                    start="1">
                                    <li class="c6"><span class="c5 c3">&#1042;&#1086;&#1079;&#1085;&#1072;&#1075;&#1088;&#1072;&#1078;&#1076;&#1077;&#1085;&#1080;&#1077; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072; &#1092;&#1086;&#1088;&#1084;&#1080;&#1088;&#1091;&#1077;&#1090;&#1089;&#1103; &#1074; &#1074;&#1080;&#1076;&#1077; &#1072;&#1073;&#1086;&#1085;&#1077;&#1085;&#1090;&#1089;&#1082;&#1086;&#1081; &#1087;&#1083;&#1072;&#1090;&#1099; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072; &#1079;&#1072; &#1087;&#1077;&#1088;&#1080;&#1086;&#1076; &#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1086;&#1081;.</span></li>
                                    <li
                                        class="c6"><span class="c5 c3">&#1044;&#1077;&#1085;&#1077;&#1078;&#1085;&#1099;&#1077; &#1089;&#1088;&#1077;&#1076;&#1089;&#1090;&#1074;&#1072; &#1087;&#1077;&#1088;&#1077;&#1095;&#1080;&#1089;&#1083;&#1103;&#1102;&#1090;&#1089;&#1103; &#1087;&#1091;&#1090;&#1077;&#1084; &#1077;&#1078;&#1077;&#1084;&#1077;&#1089;&#1103;&#1095;&#1085;&#1099;&#1093; &#1086;&#1090;&#1095;&#1080;&#1089;&#1083;&#1077;&#1085;&#1080;&#1081; (&#1087;&#1086;&#1076;&#1087;&#1080;&#1089;&#1082;&#1072;) &#1072;&#1073;&#1086;&#1085;&#1077;&#1085;&#1090;&#1089;&#1082;&#1086;&#1081; &#1087;&#1083;&#1072;&#1090;&#1099; &#1085;&#1072; &#1089;&#1095;&#1077;&#1090; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072; &#1074; &#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1086;&#1074;&#1072;&#1085;&#1085;&#1086;&#1084; &#1089;&#1090;&#1086;&#1088;&#1086;&#1085;&#1072;&#1084;&#1080; &#1088;&#1072;&#1079;&#1084;&#1077;&#1088;&#1077;.</span></li>
                                        <li
                                            class="c6"><span class="c5 c3">&#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1091; &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1103;&#1077;&#1090;&#1089;&#1103; &#1090;&#1077;&#1089;&#1090;&#1086;&#1074;&#1099;&#1081; &#1073;&#1077;&#1089;&#1087;&#1083;&#1072;&#1090;&#1085;&#1099;&#1081; &#1076;&#1086;&#1089;&#1090;&#1091;&#1087; &#1082; &#1091;&#1089;&#1083;&#1091;&#1075;&#1072;&#1084; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072; &#1089;&#1088;&#1086;&#1082;&#1086;&#1084; 60 (&#1096;&#1077;&#1089;&#1090;&#1100;&#1076;&#1077;&#1089;&#1103;&#1090;) &#1076;&#1085;&#1077;&#1081; &#1087;&#1088;&#1080; &#1087;&#1077;&#1088;&#1074;&#1080;&#1095;&#1085;&#1086;&#1081; &#1088;&#1077;&#1075;&#1080;&#1089;&#1090;&#1088;&#1072;&#1094;&#1080;&#1080; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072; &#1089;&#1086; &#1076;&#1085;&#1103; &#1072;&#1082;&#1090;&#1080;&#1074;&#1072;&#1094;&#1080;&#1080; &#1080;&#1084; &#1084;&#1072;&#1075;&#1072;&#1079;&#1080;&#1085;&#1072; (&#1082;&#1072;&#1090;&#1072;&#1083;&#1086;&#1075;&#1072;) &#1090;&#1086;&#1074;&#1072;&#1088;&#1086;&#1074;, &#1077;&#1089;&#1083;&#1080; &#1076;&#1086;&#1087;&#1086;&#1083;&#1085;&#1080;&#1090;&#1077;&#1083;&#1100;&#1085;&#1099;&#1084; &#1089;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1077;&#1084; &#1089;&#1090;&#1086;&#1088;&#1086;&#1085; &#1085;&#1077; &#1087;&#1088;&#1077;&#1076;&#1091;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1086; &#1080;&#1085;&#1086;&#1077;.</span></li>
                                            <li
                                                class="c6"><span class="c5 c3">&#1060;&#1086;&#1088;&#1084;&#1072; &#1086;&#1087;&#1083;&#1072;&#1090;&#1099; &#1086;&#1087;&#1088;&#1077;&#1076;&#1077;&#1083;&#1103;&#1077;&#1090;&#1089;&#1103; &#1089;&#1083;&#1077;&#1076;&#1091;&#1102;&#1097;&#1080;&#1084; &#1086;&#1073;&#1088;&#1072;&#1079;&#1086;&#1084;. &#1055;&#1086; &#1080;&#1089;&#1090;&#1077;&#1095;&#1077;&#1085;&#1080;&#1080; &#1090;&#1077;&#1089;&#1090;&#1086;&#1074;&#1086;&#1075;&#1086; &#1073;&#1077;&#1089;&#1087;&#1083;&#1072;&#1090;&#1085;&#1086;&#1075;&#1086; &#1076;&#1086;&#1089;&#1090;&#1091;&#1087;&#1072; &#1082; &#1091;&#1089;&#1083;&#1091;&#1075;&#1072;&#1084; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1077;&#1094; &#1074;&#1085;&#1086;&#1089;&#1080;&#1090; &#1072;&#1074;&#1072;&#1085;&#1089;&#1086;&#1074;&#1099;&#1081; &#1087;&#1083;&#1072;&#1090;&#1077;&#1078; &#1079;&#1072; &#1056;&#1072;&#1089;&#1095;&#1077;&#1090;&#1085;&#1099;&#1081; &#1087;&#1077;&#1088;&#1080;&#1086;&#1076; &#1085;&#1072; &#1089;&#1095;&#1105;&#1090; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072; &#1087;&#1091;&#1090;&#1077;&#1084; &#1087;&#1086;&#1076;&#1082;&#1083;&#1102;&#1095;&#1077;&#1085;&#1080;&#1103; &#1087;&#1086;&#1076;&#1087;&#1080;&#1089;&#1082;&#1080;. &#1042; &#1076;&#1072;&#1083;&#1100;&#1085;&#1077;&#1081;&#1096;&#1077;&#1084; &#1089;&#1087;&#1080;&#1089;&#1072;&#1085;&#1080;&#1103; &#1087;&#1083;&#1072;&#1090;&#1099; &#1079;&#1072; &#1056;&#1072;&#1089;&#1095;&#1077;&#1090;&#1085;&#1099;&#1081; &#1087;&#1077;&#1088;&#1080;&#1086;&#1076; &#1087;&#1088;&#1086;&#1080;&#1079;&#1074;&#1086;&#1076;&#1103;&#1090;&#1089;&#1103; &#1072;&#1074;&#1090;&#1086;&#1084;&#1072;&#1090;&#1080;&#1095;&#1077;&#1089;&#1082;&#1080; &#1085;&#1072; &#1086;&#1089;&#1085;&#1086;&#1074;&#1072;&#1085;&#1080;&#1080; &#1087;&#1086;&#1076;&#1087;&#1080;&#1089;&#1082;&#1080;.</span></li>
                                                <li
                                                    class="c6"><span class="c3">&#1056;&#1072;&#1089;&#1095;&#1077;&#1090;&#1085;&#1099;&#1081; &#1087;&#1077;&#1088;&#1080;&#1086;&#1076; &#1091;&#1089;&#1090;&#1072;&#1085;&#1072;&#1074;&#1083;&#1080;&#1074;&#1072;&#1077;&#1090;&#1089;&#1103; &#1089;&#1090;&#1086;&#1088;&#1086;&#1085;&#1072;&#1084;&#1080; &#1089;&#1088;&#1086;&#1082;&#1086;&#1084; &#1074; </span>
                                                    <span
                                                        class="c3">30</span><span class="c3">&nbsp;(&#1090;&#1088;&#1080;&#1076;&#1094;&#1072;&#1090;&#1100;) &#1082;&#1072;&#1083;&#1077;&#1085;&#1076;&#1072;&#1088;&#1085;&#1099;&#1093; &#1076;&#1085;&#1077;&#1081;.</span></li>
                                                        <li
                                                            class="c6"><span class="c5 c3">&#1042; &#1089;&#1083;&#1091;&#1095;&#1072;&#1077; &#1085;&#1072;&#1088;&#1091;&#1096;&#1077;&#1085;&#1080;&#1103; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1086;&#1073;&#1103;&#1079;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;&#1072; &#1087;&#1086; &#1086;&#1087;&#1083;&#1072;&#1090;&#1077; &#1074; &#1090;&#1077;&#1095;&#1077;&#1085;&#1080;&#1077; &#1089;&#1091;&#1090;&#1086;&#1082; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089; &#1087;&#1088;&#1080;&#1086;&#1089;&#1090;&#1072;&#1085;&#1072;&#1074;&#1083;&#1080;&#1074;&#1072;&#1077;&#1090; &#1076;&#1086;&#1089;&#1090;&#1091;&#1087; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1086;&#1074; &#1082; &#1088;&#1072;&#1079;&#1084;&#1077;&#1097;&#1077;&#1085;&#1085;&#1099;&#1084; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1090;&#1086;&#1074;&#1072;&#1088;&#1085;&#1099;&#1084; &#1087;&#1088;&#1077;&#1076;&#1083;&#1086;&#1078;&#1077;&#1085;&#1080;&#1103;&#1084;.</span></li>
                                                            <li
                                                                class="c6"><span class="c3">&#1052;&#1086;&#1084;&#1077;&#1085;&#1090;&#1086;&#1084; &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1086;&#1073;&#1103;&#1079;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;&#1072; &#1087;&#1086; &#1086;&#1087;&#1083;&#1072;&#1090;&#1077; &#1091;&#1089;&#1083;&#1091;&#1075; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072; &#1089;&#1095;&#1080;&#1090;&#1072;&#1077;&#1090;&#1089;&#1103; &#1084;&#1086;&#1084;&#1077;&#1085;&#1090; &#1079;&#1072;&#1095;&#1080;&#1089;&#1083;&#1077;&#1085;&#1080;&#1103; &#1076;&#1077;&#1085;&#1077;&#1078;&#1085;&#1099;&#1093; &#1089;&#1088;&#1077;&#1076;&#1089;&#1090;&#1074; &#1085;&#1072; &#1088;&#1072;&#1089;&#1095;&#1077;&#1090;&#1085;&#1099;&#1081; &#1089;&#1095;&#1077;&#1090; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072;.</span>
                                                                <span
                                                                    class="c16">&nbsp;</span>
                                                                    </li>
                                                                    <li class="c6"><span class="c5 c3">&#1057;&#1077;&#1088;&#1074;&#1080;&#1089; &#1074;&#1087;&#1088;&#1072;&#1074;&#1077; &#1074; &#1086;&#1076;&#1085;&#1086;&#1089;&#1090;&#1086;&#1088;&#1086;&#1085;&#1085;&#1077;&#1084; &#1087;&#1086;&#1088;&#1103;&#1076;&#1082;&#1077; &#1080;&#1079;&#1084;&#1077;&#1085;&#1103;&#1090;&#1100; &#1088;&#1072;&#1079;&#1084;&#1077;&#1088; &#1072;&#1073;&#1086;&#1085;&#1077;&#1085;&#1090;&#1089;&#1082;&#1086;&#1081; &#1087;&#1083;&#1072;&#1090;&#1099;, &#1087;&#1086;&#1088;&#1103;&#1076;&#1086;&#1082; &#1080; &#1089;&#1088;&#1086;&#1082;&#1080; &#1077;&#1077; &#1091;&#1087;&#1083;&#1072;&#1090;&#1099; &#1087;&#1088;&#1080; &#1091;&#1089;&#1083;&#1086;&#1074;&#1080;&#1080; &#1085;&#1072;&#1087;&#1088;&#1072;&#1074;&#1083;&#1077;&#1085;&#1080;&#1103; &#1059;&#1074;&#1077;&#1076;&#1086;&#1084;&#1083;&#1077;&#1085;&#1080;&#1103; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1091; &#1074; 14-&#1076;&#1085;&#1077;&#1074;&#1085;&#1099;&#1081; &#1089;&#1088;&#1086;&#1082; &#1076;&#1086; &#1074;&#1089;&#1090;&#1091;&#1087;&#1083;&#1077;&#1085;&#1080;&#1103; &#1091;&#1082;&#1072;&#1079;&#1072;&#1085;&#1085;&#1099;&#1093; &#1080;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1081; &#1074; &#1089;&#1080;&#1083;&#1091;.</span></li>
                                </ol>
                                <p class="c10 c21"><span class="c5 c11">&nbsp;</span></p>
                                <p class="c7"><span class="c2">4. &#1055;&#1086;&#1088;&#1103;&#1076;&#1086;&#1082; &#1086;&#1092;&#1086;&#1088;&#1084;&#1083;&#1077;&#1085;&#1080;&#1103; &#1079;&#1072;&#1082;&#1072;&#1079;&#1072;</span></p>
                                <ol class="c13 lst-kix_ewhhp7wzm8nf-0 start"
                                    start="1">
                                    <li class="c6"><span class="c5 c3">&#1047;&#1072;&#1082;&#1072;&#1079; &#1058;&#1086;&#1074;&#1072;&#1088;&#1072; &#1086;&#1089;&#1091;&#1097;&#1077;&#1089;&#1090;&#1074;&#1083;&#1103;&#1077;&#1090;&#1089;&#1103; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1086;&#1084; &#1095;&#1077;&#1088;&#1077;&#1079; &#1089;&#1090;&#1088;&#1072;&#1085;&#1080;&#1094;&#1091; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077;.</span></li>
                                    <li
                                        class="c6"><span class="c5 c3">&#1042;&#1089;&#1077; &#1088;&#1072;&#1089;&#1095;&#1077;&#1090;&#1099;, &#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1086;&#1074;&#1072;&#1085;&#1080;&#1077; &#1089;&#1087;&#1086;&#1089;&#1086;&#1073;&#1072;, &#1089;&#1088;&#1086;&#1082;&#1086;&#1074; &#1080; &#1089;&#1090;&#1086;&#1080;&#1084;&#1086;&#1089;&#1090;&#1080; &#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1082;&#1080; &#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1086;&#1074;&#1099;&#1074;&#1072;&#1102;&#1090;&#1089;&#1103; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1086;&#1084; &#1080; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1089;&#1072;&#1084;&#1086;&#1089;&#1090;&#1086;&#1103;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086;.</span></li>
                                        <li
                                            class="c6"><span class="c3">&#1042; &#1094;&#1077;&#1083;&#1103;&#1093; &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1076;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1086;&#1074; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1077;&#1094; &#1074;&#1087;&#1088;&#1072;&#1074;&#1077; &#1087;&#1086;&#1083;&#1091;&#1095;&#1072;&#1090;&#1100; &#1076;&#1086;&#1087;&#1086;&#1083;&#1085;&#1080;&#1090;&#1077;&#1083;&#1100;&#1085;&#1099;&#1077; &#1076;&#1072;&#1085;&#1085;&#1099;&#1077; &#1086; &#1055;&#1086;&#1082;&#1091;&#1087;&#1072;&#1090;&#1077;&#1083;&#1077; &#1074; &#1088;&#1072;&#1084;&#1082;&#1072;&#1093; &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1103;&#1077;&#1084;&#1099;&#1093; &#1084;&#1077;&#1078;&#1076;&#1091; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1080; &#1055;&#1086;&#1082;&#1091;&#1087;&#1072;&#1090;&#1077;&#1083;&#1077;&#1084; &#1074;&#1079;&#1072;&#1080;&#1084;&#1085;&#1099;&#1093; &#1086;&#1073;&#1103;&#1079;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;</span>
                                            <span
                                                class="c3">. &#1057;&#1077;&#1088;&#1074;&#1080;&#1089; &#1085;&#1077; &#1085;&#1077;&#1089;&#1077;&#1090; &#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1077;&#1085;&#1085;&#1086;&#1089;&#1090;&#1080; &#1079;&#1072;
                                                &#1087;&#1086;&#1083;&#1091;&#1095;&#1077;&#1085;&#1080;&#1077; &#1080; &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1091; &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1077;&#1085;&#1085;&#1099;&#1093;
                                                &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1091; &#1055;&#1086;&#1082;&#1091;&#1087;&#1072;&#1090;&#1077;&#1083;&#1103;&#1084;&#1080; &#1080;&#1093; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093;
                                                &#1080; &#1087;&#1083;&#1072;&#1090;&#1077;&#1078;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093;.</span>
                                                </li>
                                                <li class="c6"><span class="c5 c3">&#1055;&#1086;&#1089;&#1083;&#1077; &#1086;&#1092;&#1086;&#1088;&#1084;&#1083;&#1077;&#1085;&#1080;&#1103; &#1047;&#1072;&#1082;&#1072;&#1079;&#1072; &#1076;&#1072;&#1085;&#1085;&#1099;&#1077; &#1086; &#1079;&#1072;&#1082;&#1072;&#1079;&#1077; &#1088;&#1077;&#1075;&#1080;&#1089;&#1090;&#1088;&#1080;&#1088;&#1091;&#1102;&#1090;&#1089;&#1103; &#1074; &#1073;&#1072;&#1079;&#1077; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072;. &#1059;&#1090;&#1074;&#1077;&#1088;&#1076;&#1080;&#1074; &#1047;&#1072;&#1082;&#1072;&#1079; &#1074;&#1099;&#1073;&#1088;&#1072;&#1085;&#1085;&#1086;&#1075;&#1086; &#1058;&#1086;&#1074;&#1072;&#1088;&#1072;, &#1050;&#1083;&#1080;&#1077;&#1085;&#1090; &#1087;&#1088;&#1080;&#1085;&#1080;&#1084;&#1072;&#1077;&#1090; &#1074;&#1089;&#1077; &#1091;&#1089;&#1083;&#1086;&#1074;&#1080;&#1103; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1075;&#1086; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103; &#1074; &#1089;&#1086;&#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1080;&#1080; &#1089; &#1091;&#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1083;&#1077;&#1085;&#1085;&#1099;&#1084; &#1087;&#1086;&#1088;&#1103;&#1076;&#1082;&#1086;&#1084;, &#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1091;&#1077;&#1090; &#1086;&#1073;&#1088;&#1072;&#1073;&#1086;&#1090;&#1082;&#1091; &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1077;&#1085;&#1085;&#1099;&#1093; &#1087;&#1077;&#1088;&#1089;&#1086;&#1085;&#1072;&#1083;&#1100;&#1085;&#1099;&#1093; &#1076;&#1072;&#1085;&#1085;&#1099;&#1093; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1086;&#1084; &#1080; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1074; &#1091;&#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1083;&#1077;&#1085;&#1085;&#1086;&#1084; &#1047;&#1072;&#1082;&#1086;&#1085;&#1086;&#1084; &#1087;&#1086;&#1088;&#1103;&#1076;&#1082;&#1077;.</span></li>
                                                <li
                                                    class="c6"><span class="c5 c3">&#1044;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088; &#1082;&#1091;&#1087;&#1083;&#1080;-&#1087;&#1088;&#1086;&#1076;&#1072;&#1078;&#1080; &#1076;&#1080;&#1089;&#1090;&#1072;&#1085;&#1094;&#1080;&#1086;&#1085;&#1085;&#1099;&#1084; &#1089;&#1087;&#1086;&#1089;&#1086;&#1073;&#1086;&#1084; &#1084;&#1077;&#1078;&#1076;&#1091; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1080; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1086;&#1084; &#1089;&#1095;&#1080;&#1090;&#1072;&#1077;&#1090;&#1089;&#1103; &#1074;&#1099;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1085;&#1099;&#1084; &#1089; &#1084;&#1086;&#1084;&#1077;&#1085;&#1090;&#1072; &#1074;&#1099;&#1076;&#1072;&#1095;&#1080; &#1089;&#1083;&#1091;&#1078;&#1073;&#1086;&#1081; &#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1082;&#1080; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1091; &#1082;&#1072;&#1089;&#1089;&#1086;&#1074;&#1086;&#1075;&#1086; &#1095;&#1077;&#1082;&#1072; &#1083;&#1080;&#1073;&#1086; &#1080;&#1085;&#1086;&#1075;&#1086; &#1076;&#1086;&#1082;&#1091;&#1084;&#1077;&#1085;&#1090;&#1072;, &#1087;&#1086;&#1076;&#1090;&#1074;&#1077;&#1088;&#1078;&#1076;&#1072;&#1102;&#1097;&#1077;&#1075;&#1086; &#1086;&#1087;&#1083;&#1072;&#1090;&#1091; &#1058;&#1086;&#1074;&#1072;&#1088;&#1072;.</span></li>
                                </ol>
                                <p class="c10 c21"><span class="c5 c15">&nbsp;</span></p>
                                <p class="c7"><span class="c2">5. &#1043;&#1072;&#1088;&#1072;&#1085;&#1090;&#1080;&#1080; &#1080; &#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1077;&#1085;&#1085;&#1086;&#1089;&#1090;&#1100; &#1089;&#1090;&#1086;&#1088;&#1086;&#1085;</span></p>
                                <ol
                                    class="c13 lst-kix_5j8jfa1lr2qn-0 start" start="1">
                                    <li class="c6"><span class="c3">&#1057;&#1077;&#1088;&#1074;&#1080;&#1089; &#1074;&#1087;&#1088;&#1072;&#1074;&#1077; &#1087;&#1088;&#1080;&#1086;&#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1080;&#1090;&#1100; &#1074;&#1099;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1077; &#1086;&#1073;&#1103;&#1079;&#1072;&#1085;&#1085;&#1086;&#1089;&#1090;&#1077;&#1081; &#1087;&#1086; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1084;&#1091; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1102; &#1074; &#1089;&#1083;&#1091;&#1095;&#1072;&#1077; &#1085;&#1077;&#1074;&#1085;&#1077;&#1089;&#1077;&#1085;&#1080;&#1103; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1087;&#1088;&#1077;&#1076;&#1086;&#1087;&#1083;&#1072;&#1090;&#1099; </span>
                                        <span
                                            class="c5 c3">&#1079;&#1072; &#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1077; &#1059;&#1089;&#1083;&#1091;&#1075;&#1072;&#1084;&#1080; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1099;.</span>
                                    </li>
                                    <li class="c6"><span class="c3">&#1057;&#1077;&#1088;&#1074;&#1080;&#1089; &#1074;&#1087;&#1088;&#1072;&#1074;&#1077; &#1074;&#1088;&#1077;&#1084;&#1077;&#1085;&#1085;&#1086; &#1087;&#1088;&#1080;&#1086;&#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1080;&#1090;&#1100; &#1086;&#1082;&#1072;&#1079;&#1072;&#1085;&#1080;&#1077; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1091; &#1091;&#1089;&#1083;&#1091;&#1075; &#1087;&#1086; &#1090;&#1077;&#1093;&#1085;&#1080;&#1095;&#1077;&#1089;&#1082;&#1080;&#1084;, &#1090;&#1077;&#1093;&#1085;&#1086;&#1083;&#1086;&#1075;&#1080;&#1095;&#1077;&#1089;&#1082;&#1080;&#1084; &#1080; &#1080;&#1085;&#1099;&#1084; &#1087;&#1088;&#1080;&#1095;&#1080;&#1085;&#1072;&#1084;, &#1087;&#1088;&#1077;&#1087;&#1103;&#1090;&#1089;&#1090;&#1074;&#1091;&#1102;&#1097;&#1080;&#1084; &#1074;&#1099;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1102; &#1086;&#1073;&#1103;&#1079;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;, &#1085;&#1072; &#1074;&#1088;&#1077;&#1084;&#1103; &#1091;&#1089;&#1090;&#1088;&#1072;&#1085;&#1077;&#1085;&#1080;&#1103; &#1090;&#1072;&#1082;&#1080;&#1093; &#1087;&#1088;&#1080;&#1095;&#1080;&#1085;. &#1055;&#1083;&#1072;&#1090;&#1072; &#1079;&#1072; &#1091;&#1089;&#1083;&#1091;&#1075;&#1080; &#1074; &#1090;&#1077;&#1095;&#1077;&#1085;&#1080;&#1077; &#1089;&#1088;&#1086;&#1082;&#1072;, &#1085;&#1072; &#1082;&#1086;&#1090;&#1086;&#1088;&#1099;&#1081; &#1073;&#1099;&#1083;&#1086; &#1087;&#1088;&#1080;&#1086;&#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1083;&#1077;&#1085;&#1086; &#1074;&#1099;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1077; &#1086;&#1073;&#1103;&#1079;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;, &#1074; &#1101;&#1090;&#1080;&#1093; &#1089;&#1083;&#1091;&#1095;&#1072;&#1103;&#1093; &#1085;&#1077; &#1074;&#1079;&#1080;&#1084;&#1072;&#1077;&#1090;&#1089;&#1103;. </span>
                                        <span
                                            class="c3">&#1055;&#1088;&#1080; &#1101;&#1090;&#1086;&#1084; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089; &#1086;&#1073;&#1103;&#1079;&#1091;&#1077;&#1090;&#1089;&#1103; &#1091;&#1074;&#1077;&#1076;&#1086;&#1084;&#1080;&#1090;&#1100;
                                            &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072; &#1086; &#1087;&#1088;&#1080;&#1086;&#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1083;&#1077;&#1085;&#1080;&#1080; &#1086;&#1082;&#1072;&#1079;&#1072;&#1085;&#1080;&#1103;
                                            &#1091;&#1089;&#1083;&#1091;&#1075; &#1074; &#1088;&#1072;&#1079;&#1091;&#1084;&#1085;&#1099;&#1081; &#1089;&#1088;&#1086;&#1082; &#1087;&#1086; &#1101;&#1083;&#1077;&#1082;&#1090;&#1088;&#1086;&#1085;&#1085;&#1086;&#1081;
                                            &#1087;&#1086;&#1095;&#1090;&#1077;, &#1087;&#1086;&#1089;&#1088;&#1077;&#1076;&#1089;&#1090;&#1074;&#1072;&#1084; &#1057;&#1052;&#1057;-&#1088;&#1072;&#1089;&#1089;&#1099;&#1083;&#1082;&#1080; &#1080;&#1083;&#1080;
                                            &#1080;&#1085;&#1099;&#1084;, &#1087;&#1086;&#1085;&#1103;&#1090;&#1085;&#1099;&#1084; &#1089;&#1090;&#1086;&#1088;&#1086;&#1085;&#1072;&#1084; &#1089;&#1087;&#1086;&#1089;&#1086;&#1073;&#1086;&#1084;, &#1089;
                                            &#1091;&#1082;&#1072;&#1079;&#1072;&#1085;&#1080;&#1077;&#1084; &#1087;&#1088;&#1080;&#1095;&#1080;&#1085; &#1085;&#1077;&#1074;&#1086;&#1079;&#1084;&#1086;&#1078;&#1085;&#1086;&#1089;&#1090;&#1080; &#1086;&#1082;&#1072;&#1079;&#1072;&#1085;&#1080;&#1103;
                                            &#1091;&#1089;&#1083;&#1091;&#1075; &#1080; &#1076;&#1072;&#1090;&#1099; &#1080; &#1074;&#1088;&#1077;&#1084;&#1077;&#1085;&#1080; &#1074;&#1086;&#1079;&#1086;&#1073;&#1085;&#1086;&#1074;&#1083;&#1077;&#1085;&#1080;&#1103;</span>
                                            <span
                                                class="c5 c3">&nbsp;&#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1077;&#1085;&#1080;&#1103; &#1059;&#1089;&#1083;&#1091;&#1075;.</span>
                                    </li>
                                    <li class="c6"><span class="c5 c3">&#1057;&#1077;&#1088;&#1074;&#1080;&#1089; &#1074;&#1087;&#1088;&#1072;&#1074;&#1077; &#1088;&#1072;&#1079;&#1084;&#1077;&#1097;&#1072;&#1090;&#1100; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1102; &#1086; &#1058;&#1086;&#1074;&#1072;&#1088;&#1072;&#1093; &#1080; &#1080;&#1093; &#1080;&#1079;&#1086;&#1073;&#1088;&#1072;&#1078;&#1077;&#1085;&#1080;&#1103;, &#1088;&#1072;&#1079;&#1084;&#1077;&#1097;&#1077;&#1085;&#1085;&#1099;&#1077; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1074; &#1050;&#1072;&#1088;&#1090;&#1086;&#1095;&#1082;&#1077; &#1058;&#1086;&#1074;&#1072;&#1088;&#1072;, &#1085;&#1072; &#1089;&#1090;&#1086;&#1088;&#1086;&#1085;&#1085;&#1080;&#1093; &#1088;&#1077;&#1089;&#1091;&#1088;&#1089;&#1072;&#1093; &#1074; &#1088;&#1077;&#1082;&#1083;&#1072;&#1084;&#1085;&#1086;-&#1084;&#1072;&#1088;&#1082;&#1077;&#1090;&#1080;&#1085;&#1075;&#1086;&#1074;&#1099;&#1093; &#1094;&#1077;&#1083;&#1103;&#1093;. &#1057;&#1090;&#1086;&#1080;&#1084;&#1086;&#1089;&#1090;&#1100; &#1088;&#1072;&#1079;&#1084;&#1077;&#1097;&#1077;&#1085;&#1080;&#1103;, &#1087;&#1086;&#1076;&#1083;&#1077;&#1078;&#1072;&#1097;&#1072;&#1103; &#1091;&#1087;&#1083;&#1072;&#1090;&#1077; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084;, &#1074;&#1082;&#1083;&#1102;&#1095;&#1077;&#1085;&#1072; &#1074; &#1074;&#1086;&#1079;&#1085;&#1072;&#1075;&#1088;&#1072;&#1078;&#1076;&#1077;&#1085;&#1080;&#1077; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072;, &#1083;&#1080;&#1073;&#1086; &#1086;&#1087;&#1088;&#1077;&#1076;&#1077;&#1083;&#1103;&#1077;&#1090;&#1089;&#1103; &#1076;&#1086;&#1087;&#1086;&#1083;&#1085;&#1080;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086;, &#1087;&#1086; &#1087;&#1088;&#1077;&#1076;&#1074;&#1072;&#1088;&#1080;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086;&#1084;&#1091; &#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1086;&#1074;&#1072;&#1085;&#1080;&#1102; &#1089; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084;. </span></li>
                                    <li
                                        class="c6"><span class="c5 c3">&#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1077;&#1094; &#1075;&#1072;&#1088;&#1072;&#1085;&#1090;&#1080;&#1088;&#1091;&#1077;&#1090;, &#1095;&#1090;&#1086; &#1074;&#1089;&#1077; &#1058;&#1086;&#1074;&#1072;&#1088;&#1099;, &#1088;&#1072;&#1079;&#1084;&#1077;&#1097;&#1072;&#1077;&#1084;&#1099;&#1077; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077; &#1080; &#1087;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1103;&#1077;&#1084;&#1099;&#1077; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1072;&#1084; &#1074; &#1089;&#1086;&#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1080;&#1080; &#1089; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1080;&#1084; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1077;&#1084;, &#1074;&#1074;&#1077;&#1076;&#1077;&#1085;&#1099; &#1074; &#1075;&#1088;&#1072;&#1078;&#1076;&#1072;&#1085;&#1089;&#1082;&#1080;&#1081; &#1086;&#1073;&#1086;&#1088;&#1086;&#1090; &#1080; &#1074;&#1074;&#1077;&#1079;&#1077;&#1085;&#1099; &#1085;&#1072; &#1090;&#1077;&#1088;&#1088;&#1080;&#1090;&#1086;&#1088;&#1080;&#1102; &#1056;&#1086;&#1089;&#1089;&#1080;&#1081;&#1089;&#1082;&#1086;&#1081; &#1060;&#1077;&#1076;&#1077;&#1088;&#1072;&#1094;&#1080;&#1080; &#1085;&#1072; &#1079;&#1072;&#1082;&#1086;&#1085;&#1085;&#1099;&#1093; &#1086;&#1089;&#1085;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103;&#1093;.</span></li>
                                        <li
                                            class="c6"><span class="c5 c3">&#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1077;&#1094; &#1075;&#1072;&#1088;&#1072;&#1085;&#1090;&#1080;&#1088;&#1091;&#1077;&#1090;, &#1095;&#1090;&#1086; &#1074;&#1089;&#1077; &#1058;&#1086;&#1074;&#1072;&#1088;&#1099;, &#1088;&#1072;&#1079;&#1084;&#1077;&#1097;&#1072;&#1077;&#1084;&#1099;&#1077; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077; &#1080; &#1087;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1103;&#1077;&#1084;&#1099;&#1077; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1072;&#1084; &#1074; &#1089;&#1086;&#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1080;&#1080; &#1089; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1080;&#1084; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1077;&#1084;, &#1089;&#1086;&#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1091;&#1102;&#1090; &#1087;&#1086; &#1082;&#1072;&#1095;&#1077;&#1089;&#1090;&#1074;&#1091; &#1086;&#1073;&#1103;&#1079;&#1072;&#1090;&#1077;&#1083;&#1100;&#1085;&#1099;&#1084; &#1090;&#1088;&#1077;&#1073;&#1086;&#1074;&#1072;&#1085;&#1080;&#1103;&#1084;.</span></li>
                                            <li
                                                class="c6"><span class="c5 c3">&#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1077;&#1094; &#1075;&#1072;&#1088;&#1072;&#1085;&#1090;&#1080;&#1088;&#1091;&#1077;&#1090; &#1088;&#1072;&#1089;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1080;&#1077; &#1089;&#1072;&#1084;&#1086;&#1089;&#1090;&#1086;&#1103;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086; &#1080; &#1079;&#1072; &#1089;&#1074;&#1086;&#1081; &#1089;&#1095;&#1077;&#1090; &#1074;&#1089;&#1077;&#1093; &#1087;&#1088;&#1077;&#1090;&#1077;&#1085;&#1079;&#1080;&#1081; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1086;&#1074; &#1087;&#1086; &#1058;&#1086;&#1074;&#1072;&#1088;&#1072;&#1084;, &#1074; &#1090;&#1086;&#1084; &#1095;&#1080;&#1089;&#1083;&#1077; &#1089;&#1074;&#1103;&#1079;&#1072;&#1085;&#1085;&#1099;&#1093; &#1089; &#1082;&#1072;&#1095;&#1077;&#1089;&#1090;&#1074;&#1086;&#1084;, &#1075;&#1072;&#1088;&#1072;&#1085;&#1090;&#1080;&#1081;&#1085;&#1099;&#1084; &#1080; &#1087;&#1086;&#1089;&#1090;&#1075;&#1072;&#1088;&#1072;&#1085;&#1090;&#1080;&#1081;&#1085;&#1099;&#1084; &#1086;&#1073;&#1089;&#1083;&#1091;&#1078;&#1080;&#1074;&#1072;&#1085;&#1080;&#1077;&#1084; &#1058;&#1086;&#1074;&#1072;&#1088;&#1086;&#1074;, &#1080; &#1086;&#1073;&#1103;&#1079;&#1091;&#1077;&#1090;&#1089;&#1103; &#1074;&#1086;&#1079;&#1084;&#1077;&#1089;&#1090;&#1080;&#1090;&#1100; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1091; &#1074;&#1089;&#1077; &#1076;&#1086;&#1082;&#1091;&#1084;&#1077;&#1085;&#1090;&#1072;&#1083;&#1100;&#1085;&#1086; &#1087;&#1086;&#1076;&#1090;&#1074;&#1077;&#1088;&#1078;&#1076;&#1077;&#1085;&#1085;&#1099;&#1077; &#1080; &#1086;&#1073;&#1086;&#1089;&#1085;&#1086;&#1074;&#1072;&#1085;&#1085;&#1099;&#1077; &#1080;&#1079;&#1076;&#1077;&#1088;&#1078;&#1082;&#1080;, &#1089;&#1074;&#1103;&#1079;&#1072;&#1085;&#1085;&#1099;&#1077; &#1089; &#1085;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1090;&#1082;&#1072;&#1084;&#1080; &#1090;&#1086;&#1074;&#1072;&#1088;&#1072;.</span></li>
                                                <li
                                                    class="c6"><span class="c5 c3">&#1042; &#1089;&#1083;&#1091;&#1095;&#1072;&#1077; &#1085;&#1077;&#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1080;&#1083;&#1080; &#1085;&#1077;&#1085;&#1072;&#1076;&#1083;&#1077;&#1078;&#1072;&#1097;&#1077;&#1075;&#1086; &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1086;&#1076;&#1085;&#1086;&#1081; &#1080;&#1079; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085; &#1086;&#1073;&#1103;&#1079;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074; &#1087;&#1086; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1084;&#1091; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1102;, &#1086;&#1085;&#1072; &#1086;&#1073;&#1103;&#1079;&#1072;&#1085;&#1072; &#1074;&#1086;&#1079;&#1084;&#1077;&#1089;&#1090;&#1080;&#1090;&#1100; &#1076;&#1088;&#1091;&#1075;&#1086;&#1081; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1077; &#1087;&#1088;&#1080;&#1095;&#1080;&#1085;&#1077;&#1085;&#1085;&#1099;&#1077; &#1090;&#1072;&#1082;&#1080;&#1084; &#1085;&#1077;&#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1077;&#1084; &#1091;&#1073;&#1099;&#1090;&#1082;&#1080; &#1074; &#1088;&#1072;&#1079;&#1084;&#1077;&#1088;&#1077; &#1076;&#1086;&#1082;&#1091;&#1084;&#1077;&#1085;&#1090;&#1072;&#1083;&#1100;&#1085;&#1086; &#1087;&#1086;&#1076;&#1090;&#1074;&#1077;&#1088;&#1078;&#1076;&#1077;&#1085;&#1085;&#1086;&#1075;&#1086; &#1088;&#1077;&#1072;&#1083;&#1100;&#1085;&#1086;&#1075;&#1086; &#1091;&#1097;&#1077;&#1088;&#1073;&#1072;.</span></li>
                                                    </ol>
                                                    <p class="c10"><span class="c5 c11">&nbsp;</span></p>
                                                    <p class="c7"><span class="c2">6. &#1047;&#1072;&#1082;&#1083;&#1102;&#1095;&#1080;&#1090;&#1077;&#1083;&#1100;&#1085;&#1099;&#1077; &#1087;&#1086;&#1083;&#1086;&#1078;&#1077;&#1085;&#1080;&#1103;</span></p>
                                                    <ol class="c13 lst-kix_5uxjq0ffbtjv-0 start"
                                                        start="1">
                                                        <li class="c6"><span class="c3">&#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1099; &#1086;&#1073;&#1103;&#1079;&#1072;&#1085;&#1099; &#1089;&#1086;&#1086;&#1073;&#1097;&#1072;&#1090;&#1100; &#1076;&#1088;&#1091;&#1075; &#1076;&#1088;&#1091;&#1075;&#1091; &#1086;&#1073; &#1080;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1103;&#1093; &#1089;&#1074;&#1086;&#1080;&#1093; &#1102;&#1088;&#1080;&#1076;&#1080;&#1095;&#1077;&#1089;&#1082;&#1080;&#1093; &#1072;&#1076;&#1088;&#1077;&#1089;&#1086;&#1074;, &#1088;&#1077;&#1082;&#1074;&#1080;&#1079;&#1080;&#1090;&#1086;&#1074;, &#1085;&#1086;&#1084;&#1077;&#1088;&#1086;&#1074; &#1090;&#1077;&#1083;&#1077;&#1092;&#1086;&#1085;&#1086;&#1074; &#1074; 7</span>
                                                            <span
                                                                class="c3">-&#1076;&#1085;&#1077;&#1074;&#1085;&#1099;&#1081; &#1089;&#1088;&#1086;&#1082;</span><span class="c5 c3">&nbsp;&#1087;&#1091;&#1090;&#1077;&#1084; &#1086;&#1090;&#1086;&#1073;&#1088;&#1072;&#1078;&#1077;&#1085;&#1080;&#1103; &#1089;&#1086;&#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1091;&#1102;&#1097;&#1077;&#1081; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1080; &#1074; &#1051;&#1080;&#1095;&#1085;&#1086;&#1084; &#1082;&#1072;&#1073;&#1080;&#1085;&#1077;&#1090;&#1077; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077;.</span></li>
                                                        <li
                                                            class="c6"><span class="c5 c3">&#1051;&#1102;&#1073;&#1099;&#1077; &#1080;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1103; &#1080; &#1076;&#1086;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1082; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1084;&#1091; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1102; &#1076;&#1077;&#1081;&#1089;&#1090;&#1074;&#1080;&#1090;&#1077;&#1083;&#1100;&#1085;&#1099; &#1083;&#1080;&#1096;&#1100; &#1087;&#1088;&#1080; &#1091;&#1089;&#1083;&#1086;&#1074;&#1080;&#1080;, &#1095;&#1090;&#1086; &#1086;&#1085;&#1080; &#1085;&#1077; &#1086;&#1089;&#1087;&#1086;&#1088;&#1077;&#1085;&#1099; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1072;&#1084;&#1080; &#1095;&#1077;&#1088;&#1077;&#1079; &#1051;&#1080;&#1095;&#1085;&#1099;&#1081; &#1082;&#1072;&#1073;&#1080;&#1085;&#1077;&#1090; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077; &#1074; &#1091;&#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1083;&#1077;&#1085;&#1085;&#1099;&#1081; &#1085;&#1072; &#1074;&#1089;&#1090;&#1091;&#1087;&#1083;&#1077;&#1085;&#1080;&#1077; &#1080;&#1079;&#1084;&#1077;&#1085;&#1077;&#1085;&#1080;&#1081; &#1074; &#1089;&#1080;&#1083;&#1091; &#1089;&#1088;&#1086;&#1082;.</span></li>
                                                            <li
                                                                class="c6"><span class="c3">&#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1077; &#1074;&#1089;&#1090;&#1091;&#1087;&#1072;&#1077;&#1090; &#1074; &#1089;&#1080;&#1083;&#1091; &#1089; &#1084;&#1086;&#1084;&#1077;&#1085;&#1090;&#1072; &#1087;&#1086;&#1076;&#1090;&#1074;&#1077;&#1088;&#1078;&#1076;&#1077;&#1085;&#1080;&#1103; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1080;&#1103; &#1089; &#1091;&#1089;&#1083;&#1086;&#1074;&#1080;&#1103;&#1084;&#1080; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1075;&#1086; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103; &#1087;&#1091;&#1090;&#1077;&#1084; &#1088;&#1077;&#1075;&#1080;&#1089;&#1090;&#1088;&#1072;&#1094;&#1080;&#1080; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077; &#1080; &#1089;&#1095;&#1080;&#1090;&#1072;&#1077;&#1090;&#1089;&#1103; &#1079;&#1072;&#1082;&#1083;&#1102;&#1095;&#1077;&#1085;&#1085;&#1099;&#1084; &#1085;&#1072; &#1085;&#1077;&#1086;&#1087;&#1088;&#1077;&#1076;&#1077;&#1083;&#1077;&#1085;&#1085;&#1099;&#1081; &#1089;&#1088;&#1086;&#1082;.</span></li>
                                                                <li
                                                                    class="c6"><span class="c5 c3">&#1053;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1077; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1077; &#1087;&#1088;&#1077;&#1082;&#1088;&#1072;&#1097;&#1072;&#1077;&#1090;&#1089;&#1103; &#1074;&#1089;&#1083;&#1077;&#1076;&#1089;&#1090;&#1074;&#1080;&#1077;:</span></li>
                                                    </ol>
                                                    <ol class="c13 lst-kix_5uxjq0ffbtjv-1 start" start="1">
                                                        <li class="c8"><span class="c5 c3">&#1086;&#1090;&#1082;&#1072;&#1079;&#1072; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072; &#1086;&#1090; &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103;;</span></li>
                                                        <li
                                                            class="c8"><span class="c5 c3">&#1086;&#1090;&#1082;&#1072;&#1079;&#1072; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072; &#1086;&#1090; &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103;;</span></li>
                                                            <li
                                                                class="c8"><span class="c5 c3">&#1085;&#1077;&#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1086;&#1073;&#1103;&#1079;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;&#1072; &#1087;&#1086; &#1086;&#1087;&#1083;&#1072;&#1090;&#1077;, &#1087;&#1088;&#1077;&#1076;&#1091;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1085;&#1086;&#1075;&#1086; &#1075;&#1083;. 3 &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103;;</span></li>
                                                                <li
                                                                    class="c8"><span class="c5 c3">&#1089;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;;</span></li>
                                                                    <li class="c8"><span class="c5 c3">&#1087;&#1088;&#1080;&#1079;&#1085;&#1072;&#1085;&#1080;&#1103; &#1086;&#1076;&#1085;&#1086;&#1081; &#1080;&#1079; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085; &#1085;&#1077;&#1089;&#1086;&#1089;&#1090;&#1086;&#1103;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086;&#1081; (&#1073;&#1072;&#1085;&#1082;&#1088;&#1086;&#1090;&#1086;&#1084;).</span></li>
                                                    </ol>
                                                    <ol class="c13 lst-kix_5uxjq0ffbtjv-0" start="5">
                                                        <li class="c6"><span class="c5 c3">&#1042; &#1089;&#1083;&#1091;&#1095;&#1072;&#1077; &#1088;&#1072;&#1089;&#1090;&#1086;&#1088;&#1078;&#1077;&#1085;&#1080;&#1103; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103; &#1074; &#1087;&#1086;&#1088;&#1103;&#1076;&#1082;&#1077; &#1087;. 6.4.1, 6.4.2. &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103;, &#1091;&#1074;&#1077;&#1076;&#1086;&#1084;&#1083;&#1077;&#1085;&#1080;&#1077; &#1086;&#1073; &#1086;&#1090;&#1082;&#1072;&#1079;&#1077; &#1086;&#1090; &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1077; &#1076;&#1086;&#1083;&#1078;&#1085;&#1086; &#1073;&#1099;&#1090;&#1100; &#1085;&#1072;&#1087;&#1088;&#1072;&#1074;&#1083;&#1077;&#1085;&#1086; &#1074; &#1089;&#1088;&#1086;&#1082; &#1085;&#1077; &#1084;&#1077;&#1085;&#1077;&#1077; 30 &#1076;&#1085;&#1077;&#1081; &#1076;&#1086; &#1084;&#1086;&#1084;&#1077;&#1085;&#1090;&#1072; &#1086;&#1082;&#1086;&#1085;&#1095;&#1072;&#1085;&#1080;&#1103; &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103;, &#1077;&#1089;&#1083;&#1080; &#1080;&#1085;&#1086;&#1077; &#1085;&#1077; &#1073;&#1091;&#1076;&#1077;&#1090; &#1089;&#1086;&#1075;&#1083;&#1072;&#1089;&#1086;&#1074;&#1072;&#1085;&#1086; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1072;&#1084;&#1080;.</span></li>
                                                        <li
                                                            class="c6"><span class="c5 c3">&#1057; &#1084;&#1086;&#1084;&#1077;&#1085;&#1090;&#1072; &#1087;&#1086;&#1083;&#1091;&#1095;&#1077;&#1085;&#1080;&#1103; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1086;&#1081; &#1091;&#1074;&#1077;&#1076;&#1086;&#1084;&#1083;&#1077;&#1085;&#1080;&#1103; &#1074; &#1087;&#1086;&#1088;&#1103;&#1076;&#1082;&#1077; &#1087;. 6.5. &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103;, &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1077; &#1076;&#1077;&#1081;&#1089;&#1090;&#1074;&#1091;&#1077;&#1090; &#1076;&#1086; &#1086;&#1082;&#1086;&#1085;&#1095;&#1072;&#1085;&#1080;&#1103; &#1086;&#1087;&#1083;&#1072;&#1095;&#1077;&#1085;&#1085;&#1086;&#1075;&#1086; &#1088;&#1072;&#1089;&#1095;&#1105;&#1090;&#1085;&#1086;&#1075;&#1086; &#1087;&#1077;&#1088;&#1080;&#1086;&#1076;&#1072;, &#1087;&#1088;&#1077;&#1076;&#1091;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1085;&#1086;&#1075;&#1086; &#1087;. 3.5 &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103;. &#1044;&#1086;&#1089;&#1088;&#1086;&#1095;&#1085;&#1086;&#1077; &#1087;&#1088;&#1077;&#1082;&#1088;&#1072;&#1097;&#1077;&#1085;&#1080;&#1077; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103; &#1080; &#1087;&#1077;&#1088;&#1077;&#1088;&#1072;&#1089;&#1095;&#1077;&#1090; &#1091;&#1089;&#1083;&#1091;&#1075; &#1085;&#1077; &#1076;&#1086;&#1087;&#1091;&#1089;&#1082;&#1072;&#1102;&#1090;&#1089;&#1103;.</span></li>
                                                            <li
                                                                class="c6"><span class="c3">&#1055;&#1086; &#1080;&#1089;&#1090;&#1077;&#1095;&#1077;&#1085;&#1080;&#1080; &#1089;&#1088;&#1086;&#1082;&#1086;&#1074;, &#1087;&#1088;&#1077;&#1076;&#1091;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1085;&#1099;&#1093; &#1087;. 6.5, 6.6 &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103;, &#1080; &#1087;&#1086;&#1089;&#1083;&#1077; &#1088;&#1072;&#1089;&#1090;&#1086;&#1088;&#1078;&#1077;&#1085;&#1080;&#1103; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103; &#1084;&#1077;&#1078;&#1076;&#1091; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1080; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1086;&#1084; &#1076;&#1086;&#1089;&#1090;&#1091;&#1087; &#1050;&#1083;&#1080;&#1077;&#1085;&#1090;&#1086;&#1074; &#1082; &#1090;&#1086;&#1074;&#1072;&#1088;&#1085;&#1099;&#1084; &#1087;&#1088;&#1077;&#1076;&#1083;&#1086;&#1078;&#1077;&#1085;&#1080;&#1103;&#1084; &#1080; &#1082;&#1072;&#1090;&#1072;&#1083;&#1086;&#1075;&#1091; &#1087;&#1088;&#1077;&#1082;&#1088;&#1072;&#1097;&#1072;&#1077;&#1090;&#1089;&#1103; &#1089; &#1084;&#1086;&#1084;&#1077;&#1085;&#1090;&#1072; &#1086;&#1082;&#1086;&#1085;&#1095;&#1072;&#1085;&#1080;&#1103; &#1087;&#1086;&#1089;&#1083;&#1077;&#1076;&#1085;&#1077;&#1075;&#1086; &#1086;&#1087;&#1083;&#1072;&#1095;&#1077;&#1085;&#1085;&#1086;&#1075;&#1086; &#1088;&#1072;&#1089;&#1095;&#1077;&#1090;&#1085;&#1086;&#1075;&#1086; &#1087;&#1077;&#1088;&#1080;&#1086;&#1076;&#1072;, &#1082;&#1072;&#1090;&#1072;&#1083;&#1086;&#1075; &#1090;&#1086;&#1074;&#1072;&#1088;&#1086;&#1074; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072; &#1084;&#1086;&#1078;&#1077;&#1090; &#1073;&#1099;&#1090;&#1100; &#1091;&#1076;&#1072;&#1083;&#1077;&#1085; &#1087;&#1086; &#1080;&#1089;&#1090;&#1077;&#1095;&#1077;&#1085;&#1080;&#1080; &#1090;&#1088;&#1077;&#1093; &#1084;&#1077;&#1089;&#1103;&#1094;&#1077;&#1074; &#1089; </span>
                                                                <span
                                                                    class="c5 c3">&#1091;&#1082;&#1072;&#1079;&#1072;&#1085;&#1085;&#1086;&#1075;&#1086; &#1084;&#1086;&#1084;&#1077;&#1085;&#1090;&#1072;.</span>
                                                                    </li>
                                                                    <li class="c6"><span class="c5 c3">&#1042;&#1089;&#1077; &#1087;&#1088;&#1072;&#1074;&#1072; &#1085;&#1072; &#1080;&#1085;&#1090;&#1077;&#1083;&#1083;&#1077;&#1082;&#1090;&#1091;&#1072;&#1083;&#1100;&#1085;&#1091;&#1102; &#1089;&#1086;&#1073;&#1089;&#1090;&#1074;&#1077;&#1085;&#1085;&#1086;&#1089;&#1090;&#1100; &#1080; &#1085;&#1072; &#1090;&#1086;&#1074;&#1072;&#1088;&#1085;&#1099;&#1077; &#1079;&#1085;&#1072;&#1082;&#1080;/&#1080;&#1085;&#1099;&#1077; &#1086;&#1073;&#1098;&#1077;&#1082;&#1090;&#1099; &#1080;&#1085;&#1090;&#1077;&#1083;&#1083;&#1077;&#1082;&#1090;&#1091;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1089;&#1086;&#1073;&#1089;&#1090;&#1074;&#1077;&#1085;&#1085;&#1086;&#1089;&#1090;&#1080; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085; (&#1074; &#1090;&#1086;&#1084; &#1095;&#1080;&#1089;&#1083;&#1077; &#1083;&#1086;&#1075;&#1086;&#1090;&#1080;&#1087;&#1099;, &#1076;&#1080;&#1079;&#1072;&#1081;&#1085;&#1099;, &#1095;&#1077;&#1088;&#1090;&#1077;&#1078;&#1080;), &#1082;&#1086;&#1090;&#1086;&#1088;&#1099;&#1077; &#1084;&#1086;&#1075;&#1091;&#1090; &#1073;&#1099;&#1090;&#1100; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1099; &#1074; &#1088;&#1072;&#1084;&#1082;&#1072;&#1093; &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103;, &#1076;&#1086;&#1087;&#1086;&#1083;&#1085;&#1080;&#1090;&#1077;&#1083;&#1100;&#1085;&#1099;&#1093; &#1089;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1081; &#1080; &#1087;&#1088;&#1080;&#1083;&#1086;&#1078;&#1077;&#1085;&#1080;&#1081; &#1082; &#1085;&#1077;&#1084;&#1091;, &#1103;&#1074;&#1083;&#1103;&#1102;&#1090;&#1089;&#1103; &#1080; &#1073;&#1091;&#1076;&#1091;&#1090; &#1086;&#1089;&#1090;&#1072;&#1074;&#1072;&#1090;&#1100;&#1089;&#1103; &#1080;&#1089;&#1082;&#1083;&#1102;&#1095;&#1080;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086;&#1081; &#1089;&#1086;&#1073;&#1089;&#1090;&#1074;&#1077;&#1085;&#1085;&#1086;&#1089;&#1090;&#1100;&#1102; &#1089;&#1086;&#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1091;&#1102;&#1097;&#1077;&#1081; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1099;. &#1053;&#1080; &#1086;&#1076;&#1085;&#1072; &#1080;&#1079; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1075;&#1086; &#1044;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1072; &#1085;&#1077; &#1076;&#1086;&#1083;&#1078;&#1085;&#1072; &#1087;&#1099;&#1090;&#1072;&#1090;&#1100;&#1089;&#1103; &#1088;&#1077;&#1075;&#1080;&#1089;&#1090;&#1088;&#1080;&#1088;&#1086;&#1074;&#1072;&#1090;&#1100; &#1083;&#1102;&#1073;&#1099;&#1077; &#1080;&#1079; &#1101;&#1090;&#1080;&#1093; &#1058;&#1086;&#1074;&#1072;&#1088;&#1085;&#1099;&#1093; &#1079;&#1085;&#1072;&#1082;&#1086;&#1074;, &#1089;&#1093;&#1086;&#1076;&#1085;&#1099;&#1093; &#1089; &#1085;&#1080;&#1084;&#1080;, &#1072; &#1090;&#1072;&#1082;&#1078;&#1077; &#1080;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1090;&#1100; &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1077;&#1085;&#1085;&#1091;&#1102; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1102; &#1080; &#1083;&#1102;&#1073;&#1099;&#1077; &#1080;&#1079; &#1101;&#1090;&#1080;&#1093; &#1058;&#1086;&#1074;&#1072;&#1088;&#1085;&#1099;&#1093; &#1079;&#1085;&#1072;&#1082;&#1086;&#1074; &#1076;&#1083;&#1103; &#1082;&#1072;&#1082;&#1080;&#1093;-&#1083;&#1080;&#1073;&#1086; &#1094;&#1077;&#1083;&#1077;&#1081;, &#1086;&#1090;&#1083;&#1080;&#1095;&#1085;&#1099;&#1093; &#1086;&#1090; &#1090;&#1077;&#1093;, &#1082;&#1086;&#1090;&#1086;&#1088;&#1099;&#1077; &#1089;&#1074;&#1103;&#1079;&#1072;&#1085;&#1099; &#1089; &#1074;&#1099;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1077;&#1084; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1075;&#1086; &#1044;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1072;, &#1086;&#1089;&#1091;&#1097;&#1077;&#1089;&#1090;&#1074;&#1083;&#1103;&#1090;&#1100; &#1082;&#1072;&#1082;&#1080;&#1077;-&#1083;&#1080;&#1073;&#1086; &#1076;&#1077;&#1081;&#1089;&#1090;&#1074;&#1080;&#1103;, &#1082;&#1086;&#1090;&#1086;&#1088;&#1099;&#1077; &#1084;&#1086;&#1075;&#1083;&#1080; &#1073;&#1099; &#1085;&#1072;&#1088;&#1091;&#1096;&#1080;&#1090;&#1100; &#1080;&#1083;&#1080; &#1089;&#1076;&#1077;&#1083;&#1072;&#1090;&#1100; &#1085;&#1077;&#1076;&#1077;&#1081;&#1089;&#1090;&#1074;&#1080;&#1090;&#1077;&#1083;&#1100;&#1085;&#1099;&#1084;&#1080; &#1087;&#1088;&#1072;&#1074;&#1072; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1099; - &#1087;&#1088;&#1072;&#1074;&#1086;&#1086;&#1073;&#1083;&#1072;&#1076;&#1072;&#1090;&#1077;&#1083;&#1103; &#1087;&#1086; &#1086;&#1090;&#1085;&#1086;&#1096;&#1077;&#1085;&#1080;&#1102; &#1082; &#1101;&#1090;&#1080;&#1084; &#1058;&#1086;&#1074;&#1072;&#1088;&#1085;&#1099;&#1084; &#1079;&#1085;&#1072;&#1082;&#1072;&#1084; &#1080; &#1080;&#1085;&#1090;&#1077;&#1083;&#1083;&#1077;&#1082;&#1090;&#1091;&#1072;&#1083;&#1100;&#1085;&#1086;&#1081; &#1089;&#1086;&#1073;&#1089;&#1090;&#1074;&#1077;&#1085;&#1085;&#1086;&#1089;&#1090;&#1080;. &#1048;&#1089;&#1087;&#1086;&#1083;&#1100;&#1079;&#1086;&#1074;&#1072;&#1085;&#1080;&#1077; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1086;&#1084; &#1080;&#1079;&#1086;&#1073;&#1088;&#1072;&#1078;&#1077;&#1085;&#1080;&#1081; &#1087;&#1088;&#1086;&#1076;&#1091;&#1082;&#1094;&#1080;&#1080;, &#1090;&#1086;&#1074;&#1072;&#1088;&#1085;&#1099;&#1093; &#1087;&#1088;&#1077;&#1076;&#1083;&#1086;&#1078;&#1077;&#1085;&#1080;&#1081; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072; &#1076;&#1086;&#1087;&#1091;&#1089;&#1082;&#1072;&#1077;&#1090;&#1089;&#1103; &#1074; &#1094;&#1077;&#1083;&#1103;&#1093; &#1087;. 5.3 &#1057;&#1086;&#1075;&#1083;&#1072;&#1096;&#1077;&#1085;&#1080;&#1103;.</span></li>
                                                                    <li
                                                                        class="c6"><span class="c5 c3">&#1042;&#1089;&#1077; &#1089;&#1087;&#1086;&#1088;&#1099; &#1080;&#1083;&#1080; &#1088;&#1072;&#1079;&#1085;&#1086;&#1075;&#1083;&#1072;&#1089;&#1080;&#1103;, &#1074;&#1086;&#1079;&#1085;&#1080;&#1082;&#1072;&#1102;&#1097;&#1080;&#1077; &#1084;&#1077;&#1078;&#1076;&#1091; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1072;&#1084;&#1080; &#1087;&#1086; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1084;&#1091; &#1044;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1091; &#1080;&#1083;&#1080; &#1074; &#1089;&#1074;&#1103;&#1079;&#1080; &#1089; &#1085;&#1080;&#1084;, &#1088;&#1072;&#1079;&#1088;&#1077;&#1096;&#1072;&#1102;&#1090;&#1089;&#1103; &#1087;&#1091;&#1090;&#1077;&#1084; &#1087;&#1077;&#1088;&#1077;&#1075;&#1086;&#1074;&#1086;&#1088;&#1086;&#1074; &#1084;&#1077;&#1078;&#1076;&#1091; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1072;&#1084;&#1080;.</span></li>
                                                                        <li
                                                                            class="c6"><span class="c5 c3">&#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1072;&#1084;&#1080; &#1087;&#1088;&#1077;&#1076;&#1091;&#1089;&#1084;&#1072;&#1090;&#1088;&#1080;&#1074;&#1072;&#1077;&#1090;&#1089;&#1103; &#1085;&#1077;&#1086;&#1073;&#1093;&#1086;&#1076;&#1080;&#1084;&#1086;&#1089;&#1090;&#1100; &#1089;&#1086;&#1073;&#1083;&#1102;&#1076;&#1077;&#1085;&#1080;&#1103; &#1086;&#1073;&#1103;&#1079;&#1072;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086;&#1075;&#1086; &#1076;&#1086;&#1089;&#1091;&#1076;&#1077;&#1073;&#1085;&#1086;&#1075;&#1086; &#1087;&#1086;&#1088;&#1103;&#1076;&#1082;&#1072; &#1088;&#1072;&#1079;&#1088;&#1077;&#1096;&#1077;&#1085;&#1080;&#1103; &#1089;&#1087;&#1086;&#1088;&#1086;&#1074; &#1074; &#1074;&#1080;&#1076;&#1077; &#1085;&#1072;&#1087;&#1088;&#1072;&#1074;&#1083;&#1077;&#1085;&#1080;&#1103; &#1087;&#1088;&#1077;&#1090;&#1077;&#1085;&#1079;&#1080;&#1080;.</span></li>
                                                                            <li
                                                                                class="c6"><span class="c5 c3">&#1057;&#1088;&#1086;&#1082; &#1088;&#1072;&#1089;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1080;&#1103; &#1087;&#1088;&#1077;&#1090;&#1077;&#1085;&#1079;&#1080;&#1080; &#1080; &#1087;&#1088;&#1077;&#1076;&#1086;&#1089;&#1090;&#1072;&#1074;&#1083;&#1077;&#1085;&#1080;&#1103; &#1086;&#1090;&#1074;&#1077;&#1090;&#1072; &#1091;&#1089;&#1090;&#1072;&#1085;&#1072;&#1074;&#1083;&#1080;&#1074;&#1072;&#1077;&#1090;&#1089;&#1103; &#1074; 15 &#1082;&#1072;&#1083;&#1077;&#1085;&#1076;&#1072;&#1088;&#1085;&#1099;&#1093; &#1076;&#1085;&#1077;&#1081;.</span></li>
                                                                                <li
                                                                                    class="c6"><span class="c5 c3">&#1042; &#1089;&#1083;&#1091;&#1095;&#1072;&#1077; &#1085;&#1077;&#1074;&#1086;&#1079;&#1084;&#1086;&#1078;&#1085;&#1086;&#1089;&#1090;&#1080; &#1088;&#1072;&#1079;&#1088;&#1077;&#1096;&#1077;&#1085;&#1080;&#1103; &#1088;&#1072;&#1079;&#1085;&#1086;&#1075;&#1083;&#1072;&#1089;&#1080;&#1081; &#1087;&#1091;&#1090;&#1077;&#1084; &#1087;&#1077;&#1088;&#1077;&#1075;&#1086;&#1074;&#1086;&#1088;&#1086;&#1074; &#1086;&#1085;&#1080; &#1087;&#1086;&#1076;&#1083;&#1077;&#1078;&#1072;&#1090; &#1088;&#1072;&#1089;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1080;&#1102; &#1074; &#1040;&#1088;&#1073;&#1080;&#1090;&#1088;&#1072;&#1078;&#1085;&#1086;&#1084; &#1089;&#1091;&#1076;&#1077; &#1057;&#1072;&#1085;&#1082;&#1090;-&#1055;&#1077;&#1090;&#1077;&#1088;&#1073;&#1091;&#1088;&#1075;&#1072; &#1080; &#1051;&#1077;&#1085;&#1080;&#1085;&#1075;&#1088;&#1072;&#1076;&#1089;&#1082;&#1086;&#1081; &#1086;&#1073;&#1083;&#1072;&#1089;&#1090;&#1080;. </span></li>
                                                                                    <li
                                                                                        class="c6"><span class="c5 c3">&#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1099; &#1086;&#1089;&#1074;&#1086;&#1073;&#1086;&#1078;&#1076;&#1072;&#1102;&#1090;&#1089;&#1103; &#1086;&#1090; &#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1077;&#1085;&#1085;&#1086;&#1089;&#1090;&#1080; &#1079;&#1072; &#1095;&#1072;&#1089;&#1090;&#1080;&#1095;&#1085;&#1086;&#1077; &#1080;&#1083;&#1080; &#1087;&#1086;&#1083;&#1085;&#1086;&#1077; &#1085;&#1077;&#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1077; &#1086;&#1073;&#1103;&#1079;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074; &#1087;&#1086; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1084;&#1091; &#1044;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1091;, &#1077;&#1089;&#1083;&#1080; &#1101;&#1090;&#1086; &#1085;&#1077;&#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1077; &#1103;&#1074;&#1080;&#1083;&#1086;&#1089;&#1100; &#1089;&#1083;&#1077;&#1076;&#1089;&#1090;&#1074;&#1080;&#1077;&#1084; &#1086;&#1073;&#1089;&#1090;&#1086;&#1103;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074; &#1085;&#1077;&#1087;&#1088;&#1077;&#1086;&#1076;&#1086;&#1083;&#1080;&#1084;&#1086;&#1081; &#1089;&#1080;&#1083;&#1099;, &#1082;&#1086;&#1090;&#1086;&#1088;&#1099;&#1077; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1099; &#1085;&#1077; &#1084;&#1086;&#1075;&#1083;&#1080; &#1087;&#1088;&#1077;&#1076;&#1074;&#1080;&#1076;&#1077;&#1090;&#1100; &#1080;&#1083;&#1080; &#1087;&#1088;&#1077;&#1076;&#1086;&#1090;&#1074;&#1088;&#1072;&#1090;&#1080;&#1090;&#1100;.</span></li>
                                                                                        <li
                                                                                            class="c6"><span class="c5 c3">&#1055;&#1088;&#1080; &#1085;&#1072;&#1089;&#1090;&#1091;&#1087;&#1083;&#1077;&#1085;&#1080;&#1080; &#1086;&#1073;&#1089;&#1090;&#1086;&#1103;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;, &#1091;&#1082;&#1072;&#1079;&#1072;&#1085;&#1085;&#1099;&#1093; &#1074; &#1087;. 6.9 &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1075;&#1086; &#1044;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1072;, &#1082;&#1072;&#1078;&#1076;&#1072;&#1103; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1072; &#1076;&#1086;&#1083;&#1078;&#1085;&#1072; &#1073;&#1077;&#1079; &#1087;&#1088;&#1086;&#1084;&#1077;&#1076;&#1083;&#1077;&#1085;&#1080;&#1103; &#1080;&#1079;&#1074;&#1077;&#1089;&#1090;&#1080;&#1090;&#1100; &#1086; &#1085;&#1080;&#1093; &#1074; &#1087;&#1080;&#1089;&#1100;&#1084;&#1077;&#1085;&#1085;&#1086;&#1084; &#1074;&#1080;&#1076;&#1077; &#1076;&#1088;&#1091;&#1075;&#1091;&#1102; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1091;. &#1048;&#1079;&#1074;&#1077;&#1097;&#1077;&#1085;&#1080;&#1077; &#1076;&#1086;&#1083;&#1078;&#1085;&#1086; &#1089;&#1086;&#1076;&#1077;&#1088;&#1078;&#1072;&#1090;&#1100; &#1076;&#1072;&#1085;&#1085;&#1099;&#1077; &#1086; &#1093;&#1072;&#1088;&#1072;&#1082;&#1090;&#1077;&#1088;&#1077; &#1086;&#1073;&#1089;&#1090;&#1086;&#1103;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;, &#1072; &#1090;&#1072;&#1082;&#1078;&#1077; &#1086;&#1092;&#1080;&#1094;&#1080;&#1072;&#1083;&#1100;&#1085;&#1099;&#1077; &#1076;&#1086;&#1082;&#1091;&#1084;&#1077;&#1085;&#1090;&#1099;, &#1091;&#1076;&#1086;&#1089;&#1090;&#1086;&#1074;&#1077;&#1088;&#1103;&#1102;&#1097;&#1080;&#1077; &#1085;&#1072;&#1083;&#1080;&#1095;&#1080;&#1077; &#1101;&#1090;&#1080;&#1093; &#1086;&#1073;&#1089;&#1090;&#1086;&#1103;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074; &#1080; &#1087;&#1086; &#1074;&#1086;&#1079;&#1084;&#1086;&#1078;&#1085;&#1086;&#1089;&#1090;&#1080; &#1076;&#1072;&#1102;&#1097;&#1080;&#1077; &#1086;&#1094;&#1077;&#1085;&#1082;&#1091; &#1080;&#1093; &#1074;&#1083;&#1080;&#1103;&#1085;&#1080;&#1103; &#1085;&#1072; &#1074;&#1086;&#1079;&#1084;&#1086;&#1078;&#1085;&#1086;&#1089;&#1090;&#1100; &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1086;&#1081; &#1089;&#1074;&#1086;&#1080;&#1093; &#1086;&#1073;&#1103;&#1079;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074; &#1087;&#1086; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1084;&#1091; &#1044;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1091;.</span></li>
                                                                                            <li
                                                                                                class="c6"><span class="c5 c3">&#1045;&#1089;&#1083;&#1080; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1072; &#1085;&#1077; &#1085;&#1072;&#1087;&#1088;&#1072;&#1074;&#1080;&#1090; &#1080;&#1083;&#1080; &#1085;&#1077;&#1089;&#1074;&#1086;&#1077;&#1074;&#1088;&#1077;&#1084;&#1077;&#1085;&#1085;&#1086; &#1085;&#1072;&#1087;&#1088;&#1072;&#1074;&#1080;&#1090; &#1080;&#1079;&#1074;&#1077;&#1097;&#1077;&#1085;&#1080;&#1077;, &#1087;&#1088;&#1077;&#1076;&#1091;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1085;&#1086;&#1077; &#1074; &#1087;. 6.10 &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1075;&#1086; &#1044;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1072;, &#1090;&#1086; &#1086;&#1085;&#1072; &#1086;&#1073;&#1103;&#1079;&#1072;&#1085;&#1072; &#1074;&#1086;&#1079;&#1084;&#1077;&#1089;&#1090;&#1080;&#1090;&#1100; &#1076;&#1088;&#1091;&#1075;&#1086;&#1081; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1077; &#1087;&#1086;&#1085;&#1077;&#1089;&#1077;&#1085;&#1085;&#1099;&#1077; &#1077;&#1102; &#1091;&#1073;&#1099;&#1090;&#1082;&#1080;.</span></li>
                                                                                                <li
                                                                                                    class="c6"><span class="c5 c3">&#1042; &#1089;&#1083;&#1091;&#1095;&#1072;&#1103;&#1093; &#1085;&#1072;&#1089;&#1090;&#1091;&#1087;&#1083;&#1077;&#1085;&#1080;&#1103; &#1086;&#1073;&#1089;&#1090;&#1086;&#1103;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;, &#1087;&#1088;&#1077;&#1076;&#1091;&#1089;&#1084;&#1086;&#1090;&#1088;&#1077;&#1085;&#1085;&#1099;&#1093; &#1074; &#1087;. 6.9 &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1075;&#1086; &#1044;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1072;, &#1089;&#1088;&#1086;&#1082; &#1074;&#1099;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1086;&#1081; &#1086;&#1073;&#1103;&#1079;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074; &#1087;&#1086; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1084;&#1091; &#1044;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1091; &#1086;&#1090;&#1086;&#1076;&#1074;&#1080;&#1075;&#1072;&#1077;&#1090;&#1089;&#1103; &#1089;&#1086;&#1088;&#1072;&#1079;&#1084;&#1077;&#1088;&#1085;&#1086; &#1074;&#1088;&#1077;&#1084;&#1077;&#1085;&#1080;, &#1074; &#1090;&#1077;&#1095;&#1077;&#1085;&#1080;&#1077; &#1082;&#1086;&#1090;&#1086;&#1088;&#1086;&#1075;&#1086; &#1076;&#1077;&#1081;&#1089;&#1090;&#1074;&#1091;&#1102;&#1090; &#1101;&#1090;&#1080; &#1086;&#1073;&#1089;&#1090;&#1086;&#1103;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;&#1072; &#1080; &#1080;&#1093; &#1087;&#1086;&#1089;&#1083;&#1077;&#1076;&#1089;&#1090;&#1074;&#1080;&#1103;.</span></li>
                                                                                                    <li
                                                                                                        class="c6"><span class="c3">&#1045;&#1089;&#1083;&#1080; &#1086;&#1073;&#1089;&#1090;&#1086;&#1103;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;&#1072;, &#1087;&#1077;&#1088;&#1077;&#1095;&#1080;&#1089;&#1083;&#1077;&#1085;&#1085;&#1099;&#1077; &#1074; &#1087;. 6.9 &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1075;&#1086; &#1044;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1072;, &#1080; &#1080;&#1093; &#1087;&#1086;&#1089;&#1083;&#1077;&#1076;&#1089;&#1090;&#1074;&#1080;&#1103; &#1087;&#1088;&#1086;&#1076;&#1086;&#1083;&#1078;&#1072;&#1102;&#1090; &#1076;&#1077;&#1081;&#1089;&#1090;&#1074;&#1086;&#1074;&#1072;&#1090;&#1100; &#1073;&#1086;&#1083;&#1077;&#1077; &#1076;&#1074;&#1091;&#1093; &#1084;&#1077;&#1089;&#1103;&#1094;&#1077;&#1074;, &#1057;&#1090;&#1086;&#1088;&#1086;&#1085;&#1099; &#1087;&#1088;&#1086;&#1074;&#1086;&#1076;&#1103;&#1090; &#1076;&#1086;&#1087;&#1086;&#1083;&#1085;&#1080;&#1090;&#1077;&#1083;&#1100;&#1085;&#1099;&#1077; &#1087;&#1077;&#1088;&#1077;&#1075;&#1086;&#1074;&#1086;&#1088;&#1099; &#1076;&#1083;&#1103; &#1074;&#1099;&#1103;&#1074;&#1083;&#1077;&#1085;&#1080;&#1103; &#1087;&#1088;&#1080;&#1077;&#1084;&#1083;&#1077;&#1084;&#1099;&#1093; &#1072;&#1083;&#1100;&#1090;&#1077;&#1088;&#1085;&#1072;&#1090;&#1080;&#1074;&#1085;&#1099;&#1093; &#1089;&#1087;&#1086;&#1089;&#1086;&#1073;&#1086;&#1074; &#1080;&#1089;&#1087;&#1086;&#1083;&#1085;&#1077;&#1085;&#1080;&#1103; &#1085;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1075;&#1086; &#1044;&#1086;&#1075;&#1086;&#1074;&#1086;&#1088;&#1072;.</span></li>
                                                    </ol>
                                                    <p class="c10"><span class="c5 c3">&nbsp;</span></p>
                                                    <p class="c10 c18"><span class="c5 c3"></span></p>
                                                    <p class="c7"><span class="c3">7. </span><span class="c0">&#1055;&#1077;&#1088;&#1077;&#1095;&#1077;&#1085;&#1100; &#1079;&#1072;&#1087;&#1088;&#1077;&#1097;&#1105;&#1085;&#1085;&#1099;&#1093; &#1082; &#1087;&#1088;&#1086;&#1076;&#1072;&#1078;&#1077; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077; &#1058;&#1086;&#1074;&#1072;&#1088;&#1086;&#1074;.</span></p>
                                                    <ol
                                                        class="c13 lst-kix_a2xpqrabpe6x-0 start" start="1">
                                                        <li class="c4"><span class="c5 c3">&#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1077;&#1094; &#1085;&#1077; &#1080;&#1084;&#1077;&#1077;&#1090; &#1087;&#1088;&#1072;&#1074;&#1072; &#1087;&#1088;&#1086;&#1080;&#1079;&#1074;&#1086;&#1076;&#1080;&#1090;&#1100; &#1088;&#1077;&#1072;&#1083;&#1080;&#1079;&#1072;&#1094;&#1080;&#1102; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077; &#1076;&#1080;&#1089;&#1090;&#1072;&#1085;&#1094;&#1080;&#1086;&#1085;&#1085;&#1099;&#1084; &#1089;&#1087;&#1086;&#1089;&#1086;&#1073;&#1086;&#1084; &#1090;&#1086;&#1074;&#1072;&#1088;&#1086;&#1074;, &#1087;&#1088;&#1086;&#1076;&#1072;&#1078;&#1072; &#1082;&#1086;&#1090;&#1086;&#1088;&#1099;&#1093; &#1076;&#1080;&#1089;&#1090;&#1072;&#1085;&#1094;&#1080;&#1086;&#1085;&#1085;&#1099;&#1084; &#1089;&#1087;&#1086;&#1089;&#1086;&#1073;&#1086;&#1084; &#1079;&#1072;&#1087;&#1088;&#1077;&#1097;&#1077;&#1085;&#1072; &#1074; &#1089;&#1086;&#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1080;&#1080; &#1089; &#1086;&#1075;&#1088;&#1072;&#1085;&#1080;&#1095;&#1077;&#1085;&#1080;&#1103;&#1084;&#1080;, &#1091;&#1089;&#1090;&#1072;&#1085;&#1086;&#1074;&#1083;&#1077;&#1085;&#1085;&#1099;&#1084;&#1080; &#1079;&#1072;&#1082;&#1086;&#1085;&#1086;&#1076;&#1072;&#1090;&#1077;&#1083;&#1100;&#1089;&#1090;&#1074;&#1086;&#1084; &#1056;&#1060; &#1080;&#1083;&#1080; &#1086;&#1075;&#1088;&#1072;&#1085;&#1080;&#1095;&#1077;&#1085;&#1099; &#1082; &#1086;&#1073;&#1086;&#1088;&#1086;&#1090;&#1091;.</span></li>
                                                        <li
                                                            class="c4"><span class="c5 c3">&#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1077;&#1094; &#1074;&#1087;&#1088;&#1072;&#1074;&#1077; &#1088;&#1072;&#1079;&#1084;&#1077;&#1097;&#1072;&#1090;&#1100; &#1074; &#1090;&#1086;&#1074;&#1072;&#1088;&#1085;&#1099;&#1093; &#1082;&#1072;&#1090;&#1072;&#1083;&#1086;&#1075;&#1072;&#1093; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077; &#1089;&#1074;&#1077;&#1076;&#1077;&#1085;&#1080;&#1103; &#1086; &#1058;&#1086;&#1074;&#1072;&#1088;&#1072;&#1093;, &#1087;&#1088;&#1086;&#1076;&#1072;&#1078;&#1072; &#1082;&#1086;&#1090;&#1086;&#1088;&#1099;&#1093; &#1076;&#1080;&#1089;&#1090;&#1072;&#1085;&#1094;&#1080;&#1086;&#1085;&#1085;&#1099;&#1084; &#1089;&#1087;&#1086;&#1089;&#1086;&#1073;&#1086;&#1084; &#1079;&#1072;&#1087;&#1088;&#1077;&#1097;&#1077;&#1085;&#1072; &#1047;&#1072;&#1082;&#1086;&#1085;&#1086;&#1084;, &#1080;&#1089;&#1082;&#1083;&#1102;&#1095;&#1080;&#1090;&#1077;&#1083;&#1100;&#1085;&#1086; &#1074; &#1080;&#1085;&#1092;&#1086;&#1088;&#1084;&#1072;&#1094;&#1080;&#1086;&#1085;&#1085;&#1099;&#1093; &#1094;&#1077;&#1083;&#1103;&#1093;.</span></li>
                                                            <li
                                                                class="c4"><span class="c5 c3">&#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1077;&#1094; &#1085;&#1077; &#1080;&#1084;&#1077;&#1077;&#1090; &#1087;&#1088;&#1072;&#1074;&#1072; &#1087;&#1088;&#1077;&#1076;&#1083;&#1072;&#1075;&#1072;&#1090;&#1100; &#1074; &#1090;&#1086;&#1074;&#1072;&#1088;&#1085;&#1099;&#1093; &#1082;&#1072;&#1090;&#1072;&#1083;&#1086;&#1075;&#1072;&#1093; &#1085;&#1072; &#1055;&#1083;&#1072;&#1090;&#1092;&#1086;&#1088;&#1084;&#1077; &#1058;&#1086;&#1074;&#1072;&#1088;&#1099;, &#1086;&#1075;&#1088;&#1072;&#1085;&#1080;&#1095;&#1077;&#1085;&#1085;&#1099;&#1077; &#1079;&#1072;&#1082;&#1086;&#1085;&#1086;&#1084; &#1082; &#1086;&#1073;&#1086;&#1088;&#1086;&#1090;&#1091; &#1085;&#1072; &#1090;&#1077;&#1088;&#1088;&#1080;&#1090;&#1086;&#1088;&#1080;&#1080; &#1056;&#1086;&#1089;&#1089;&#1080;&#1081;&#1089;&#1082;&#1086;&#1081; &#1060;&#1077;&#1076;&#1077;&#1088;&#1072;&#1094;&#1080;&#1080;.</span></li>
                                                                <li
                                                                    class="c4"><span class="c5 c3">&#1057;&#1077;&#1088;&#1074;&#1080;&#1089; &#1085;&#1077; &#1085;&#1077;&#1089;&#1077;&#1090; &#1086;&#1090;&#1074;&#1077;&#1090;&#1089;&#1090;&#1074;&#1077;&#1085;&#1085;&#1086;&#1089;&#1090;&#1080; &#1079;&#1072; &#1085;&#1072;&#1088;&#1091;&#1096;&#1077;&#1085;&#1080;&#1077; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1072;&#1084;&#1080; &#1087;. 7.1-7.3 &#1053;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1081; &#1054;&#1092;&#1077;&#1088;&#1090;&#1099;. &#1042;&#1089;&#1077;, &#1074;&#1086;&#1079;&#1085;&#1080;&#1082;&#1096;&#1080;&#1077; &#1091; &#1057;&#1077;&#1088;&#1074;&#1080;&#1089;&#1072; &#1074; &#1089;&#1074;&#1103;&#1079;&#1080; &#1089; &#1085;&#1072;&#1088;&#1091;&#1096;&#1077;&#1085;&#1080;&#1077;&#1084; &#1055;&#1088;&#1086;&#1076;&#1072;&#1074;&#1094;&#1086;&#1084; &#1091;&#1089;&#1083;&#1086;&#1074;&#1080;&#1081; &#1053;&#1072;&#1089;&#1090;&#1086;&#1103;&#1097;&#1077;&#1081; &#1054;&#1092;&#1077;&#1088;&#1090;&#1099;, &#1080;&#1079;&#1076;&#1077;&#1088;&#1078;&#1082;&#1080; &#1087;&#1086;&#1076;&#1083;&#1077;&#1078;&#1072;&#1090; &#1074;&#1086;&#1079;&#1084;&#1077;&#1097;&#1077;&#1085;&#1080;&#1102; &#1074; &#1087;&#1086;&#1083;&#1085;&#1086;&#1084; &#1086;&#1073;&#1098;&#1077;&#1084;&#1077;. </span></li>
                                                                    </ol>
                                                                    <p class="c10 c18 c24"><span class="c5 c3"></span></p>
                                                                    <p class="c10 c18"><span class="c5 c3"></span></p>
                                                                    <p class="c10 c18"><span class="c5 c3"></span></p>
                                                                    <p class="c10 c18"><span class="c5 c3"></span></p>
</body>

</html>`;
